export const testMockData = {
  _id: '671923ae6bc3007257f366ec',
  type: 'paid',
  percentile: {
    percentileData: {
      _id: '673c75ef2621a3331bdc7b55',
      title: 'JEE Main Full Test',
      description: 'This percentile calculation is done on the basis of JEE Main 2024 (27 Jan Shift 1) data',
      consolationText:
        'Buckle up! Your score is below the 90 percentile. Analyze properly and keep pushing forward to improve.',
      data: [
        {
          _id: '673c75ef2621a3331bdc7b56',
          percentile: 99.9,
          score: 278,
        },
        {
          _id: '673c75ef2621a3331bdc7b57',
          percentile: 99.8875,
          score: 277,
        },
        {
          _id: '673c75ef2621a3331bdc7b58',
          percentile: 99.875,
          score: 276,
        },
        {
          _id: '673c75ef2621a3331bdc7b59',
          percentile: 99.8625,
          score: 275,
        },
        {
          _id: '673c75ef2621a3331bdc7b5a',
          percentile: 99.85,
          score: 274,
        },
        {
          _id: '673c75ef2621a3331bdc7b5b',
          percentile: 99.8375,
          score: 273,
        },
        {
          _id: '673c75ef2621a3331bdc7b5c',
          percentile: 99.825,
          score: 272,
        },
        {
          _id: '673c75ef2621a3331bdc7b5d',
          percentile: 99.8125,
          score: 271,
        },
        {
          _id: '673c75ef2621a3331bdc7b5e',
          percentile: 99.8,
          score: 270,
        },
        {
          _id: '673c75ef2621a3331bdc7b5f',
          percentile: 99.78,
          score: 269,
        },
        {
          _id: '673c75ef2621a3331bdc7b60',
          percentile: 99.76,
          score: 268,
        },
        {
          _id: '673c75ef2621a3331bdc7b61',
          percentile: 99.74,
          score: 267,
        },
        {
          _id: '673c75ef2621a3331bdc7b62',
          percentile: 99.72,
          score: 266,
        },
        {
          _id: '673c75ef2621a3331bdc7b63',
          percentile: 99.7,
          score: 265,
        },
        {
          _id: '673c75ef2621a3331bdc7b64',
          percentile: 99.683333,
          score: 264,
        },
        {
          _id: '673c75ef2621a3331bdc7b65',
          percentile: 99.666667,
          score: 263,
        },
        {
          _id: '673c75ef2621a3331bdc7b66',
          percentile: 99.65,
          score: 262,
        },
        {
          _id: '673c75ef2621a3331bdc7b67',
          percentile: 99.633333,
          score: 261,
        },
        {
          _id: '673c75ef2621a3331bdc7b68',
          percentile: 99.616667,
          score: 260,
        },
        {
          _id: '673c75ef2621a3331bdc7b69',
          percentile: 99.6,
          score: 259,
        },
        {
          _id: '673c75ef2621a3331bdc7b6a',
          percentile: 99.58,
          score: 258,
        },
        {
          _id: '673c75ef2621a3331bdc7b6b',
          percentile: 99.56,
          score: 257,
        },
        {
          _id: '673c75ef2621a3331bdc7b6c',
          percentile: 99.54,
          score: 256,
        },
        {
          _id: '673c75ef2621a3331bdc7b6d',
          percentile: 99.52,
          score: 255,
        },
        {
          _id: '673c75ef2621a3331bdc7b6e',
          percentile: 99.5,
          score: 254,
        },
        {
          _id: '673c75ef2621a3331bdc7b6f',
          percentile: 99.475,
          score: 253,
        },
        {
          _id: '673c75ef2621a3331bdc7b70',
          percentile: 99.45,
          score: 252,
        },
        {
          _id: '673c75ef2621a3331bdc7b71',
          percentile: 99.425,
          score: 251,
        },
        {
          _id: '673c75ef2621a3331bdc7b72',
          percentile: 99.4,
          score: 250,
        },
        {
          _id: '673c75ef2621a3331bdc7b73',
          percentile: 99.38,
          score: 249,
        },
        {
          _id: '673c75ef2621a3331bdc7b74',
          percentile: 99.36,
          score: 248,
        },
        {
          _id: '673c75ef2621a3331bdc7b75',
          percentile: 99.34,
          score: 247,
        },
        {
          _id: '673c75ef2621a3331bdc7b76',
          percentile: 99.32,
          score: 246,
        },
        {
          _id: '673c75ef2621a3331bdc7b77',
          percentile: 99.3,
          score: 245,
        },
        {
          _id: '673c75ef2621a3331bdc7b78',
          percentile: 99.266667,
          score: 244,
        },
        {
          _id: '673c75ef2621a3331bdc7b79',
          percentile: 99.233333,
          score: 243,
        },
        {
          _id: '673c75ef2621a3331bdc7b7a',
          percentile: 99.2,
          score: 242,
        },
        {
          _id: '673c75ef2621a3331bdc7b7b',
          percentile: 99.166667,
          score: 241,
        },
        {
          _id: '673c75ef2621a3331bdc7b7c',
          percentile: 99.133333,
          score: 240,
        },
        {
          _id: '673c75ef2621a3331bdc7b7d',
          percentile: 99.1,
          score: 239,
        },
        {
          _id: '673c75ef2621a3331bdc7b7e',
          percentile: 99.066667,
          score: 238,
        },
        {
          _id: '673c75ef2621a3331bdc7b7f',
          percentile: 99.033333,
          score: 237,
        },
        {
          _id: '673c75ef2621a3331bdc7b80',
          percentile: 99,
          score: 236,
        },
        {
          _id: '673c75ef2621a3331bdc7b81',
          percentile: 98.961538,
          score: 235,
        },
        {
          _id: '673c75ef2621a3331bdc7b82',
          percentile: 98.923077,
          score: 234,
        },
        {
          _id: '673c75ef2621a3331bdc7b83',
          percentile: 98.884615,
          score: 233,
        },
        {
          _id: '673c75ef2621a3331bdc7b84',
          percentile: 98.846154,
          score: 232,
        },
        {
          _id: '673c75ef2621a3331bdc7b85',
          percentile: 98.807692,
          score: 231,
        },
        {
          _id: '673c75ef2621a3331bdc7b86',
          percentile: 98.769231,
          score: 230,
        },
        {
          _id: '673c75ef2621a3331bdc7b87',
          percentile: 98.730769,
          score: 229,
        },
        {
          _id: '673c75ef2621a3331bdc7b88',
          percentile: 98.692308,
          score: 228,
        },
        {
          _id: '673c75ef2621a3331bdc7b89',
          percentile: 98.653846,
          score: 227,
        },
        {
          _id: '673c75ef2621a3331bdc7b8a',
          percentile: 98.615385,
          score: 226,
        },
        {
          _id: '673c75ef2621a3331bdc7b8b',
          percentile: 98.576923,
          score: 225,
        },
        {
          _id: '673c75ef2621a3331bdc7b8c',
          percentile: 98.538462,
          score: 224,
        },
        {
          _id: '673c75ef2621a3331bdc7b8d',
          percentile: 98.5,
          score: 223,
        },
        {
          _id: '673c75ef2621a3331bdc7b8e',
          percentile: 98.45,
          score: 222,
        },
        {
          _id: '673c75ef2621a3331bdc7b8f',
          percentile: 98.4,
          score: 221,
        },
        {
          _id: '673c75ef2621a3331bdc7b90',
          percentile: 98.35,
          score: 220,
        },
        {
          _id: '673c75ef2621a3331bdc7b91',
          percentile: 98.3,
          score: 219,
        },
        {
          _id: '673c75ef2621a3331bdc7b92',
          percentile: 98.25,
          score: 218,
        },
        {
          _id: '673c75ef2621a3331bdc7b93',
          percentile: 98.2,
          score: 217,
        },
        {
          _id: '673c75ef2621a3331bdc7b94',
          percentile: 98.15,
          score: 216,
        },
        {
          _id: '673c75ef2621a3331bdc7b95',
          percentile: 98.1,
          score: 215,
        },
        {
          _id: '673c75ef2621a3331bdc7b96',
          percentile: 98.05,
          score: 214,
        },
        {
          _id: '673c75ef2621a3331bdc7b97',
          percentile: 98,
          score: 213,
        },
        {
          _id: '673c75ef2621a3331bdc7b98',
          percentile: 97.944444,
          score: 212,
        },
        {
          _id: '673c75ef2621a3331bdc7b99',
          percentile: 97.888889,
          score: 211,
        },
        {
          _id: '673c75ef2621a3331bdc7b9a',
          percentile: 97.833333,
          score: 210,
        },
        {
          _id: '673c75ef2621a3331bdc7b9b',
          percentile: 97.777778,
          score: 209,
        },
        {
          _id: '673c75ef2621a3331bdc7b9c',
          percentile: 97.722222,
          score: 208,
        },
        {
          _id: '673c75ef2621a3331bdc7b9d',
          percentile: 97.666667,
          score: 207,
        },
        {
          _id: '673c75ef2621a3331bdc7b9e',
          percentile: 97.611111,
          score: 206,
        },
        {
          _id: '673c75ef2621a3331bdc7b9f',
          percentile: 97.555556,
          score: 205,
        },
        {
          _id: '673c75ef2621a3331bdc7ba0',
          percentile: 97.5,
          score: 204,
        },
        {
          _id: '673c75ef2621a3331bdc7ba1',
          percentile: 97.4375,
          score: 203,
        },
        {
          _id: '673c75ef2621a3331bdc7ba2',
          percentile: 97.375,
          score: 202,
        },
        {
          _id: '673c75ef2621a3331bdc7ba3',
          percentile: 97.3125,
          score: 201,
        },
        {
          _id: '673c75ef2621a3331bdc7ba4',
          percentile: 97.25,
          score: 200,
        },
        {
          _id: '673c75ef2621a3331bdc7ba5',
          percentile: 97.1875,
          score: 199,
        },
        {
          _id: '673c75ef2621a3331bdc7ba6',
          percentile: 97.125,
          score: 198,
        },
        {
          _id: '673c75ef2621a3331bdc7ba7',
          percentile: 97.0625,
          score: 197,
        },
        {
          _id: '673c75ef2621a3331bdc7ba8',
          percentile: 97,
          score: 196,
        },
        {
          _id: '673c75ef2621a3331bdc7ba9',
          percentile: 96.916667,
          score: 195,
        },
        {
          _id: '673c75ef2621a3331bdc7baa',
          percentile: 96.833333,
          score: 194,
        },
        {
          _id: '673c75ef2621a3331bdc7bab',
          percentile: 96.75,
          score: 193,
        },
        {
          _id: '673c75ef2621a3331bdc7bac',
          percentile: 96.666667,
          score: 192,
        },
        {
          _id: '673c75ef2621a3331bdc7bad',
          percentile: 96.583333,
          score: 191,
        },
        {
          _id: '673c75ef2621a3331bdc7bae',
          percentile: 96.5,
          score: 190,
        },
        {
          _id: '673c75ef2621a3331bdc7baf',
          percentile: 96.416667,
          score: 189,
        },
        {
          _id: '673c75ef2621a3331bdc7bb0',
          percentile: 96.333333,
          score: 188,
        },
        {
          _id: '673c75ef2621a3331bdc7bb1',
          percentile: 96.25,
          score: 187,
        },
        {
          _id: '673c75ef2621a3331bdc7bb2',
          percentile: 96.166667,
          score: 186,
        },
        {
          _id: '673c75ef2621a3331bdc7bb3',
          percentile: 96.083333,
          score: 185,
        },
        {
          _id: '673c75ef2621a3331bdc7bb4',
          percentile: 96,
          score: 184,
        },
        {
          _id: '673c75ef2621a3331bdc7bb5',
          percentile: 95.916667,
          score: 183,
        },
        {
          _id: '673c75ef2621a3331bdc7bb6',
          percentile: 95.833333,
          score: 182,
        },
        {
          _id: '673c75ef2621a3331bdc7bb7',
          percentile: 95.75,
          score: 181,
        },
        {
          _id: '673c75ef2621a3331bdc7bb8',
          percentile: 95.666667,
          score: 180,
        },
        {
          _id: '673c75ef2621a3331bdc7bb9',
          percentile: 95.583333,
          score: 179,
        },
        {
          _id: '673c75ef2621a3331bdc7bba',
          percentile: 95.5,
          score: 178,
        },
        {
          _id: '673c75ef2621a3331bdc7bbb',
          percentile: 95.4,
          score: 177,
        },
        {
          _id: '673c75ef2621a3331bdc7bbc',
          percentile: 95.3,
          score: 176,
        },
        {
          _id: '673c75ef2621a3331bdc7bbd',
          percentile: 95.2,
          score: 175,
        },
        {
          _id: '673c75ef2621a3331bdc7bbe',
          percentile: 95.1,
          score: 174,
        },
        {
          _id: '673c75ef2621a3331bdc7bbf',
          percentile: 95,
          score: 173,
        },
        {
          _id: '673c75ef2621a3331bdc7bc0',
          percentile: 94.875,
          score: 172,
        },
        {
          _id: '673c75ef2621a3331bdc7bc1',
          percentile: 94.75,
          score: 171,
        },
        {
          _id: '673c75ef2621a3331bdc7bc2',
          percentile: 94.625,
          score: 170,
        },
        {
          _id: '673c75ef2621a3331bdc7bc3',
          percentile: 94.5,
          score: 169,
        },
        {
          _id: '673c75ef2621a3331bdc7bc4',
          percentile: 94.375,
          score: 168,
        },
        {
          _id: '673c75ef2621a3331bdc7bc5',
          percentile: 94.25,
          score: 167,
        },
        {
          _id: '673c75ef2621a3331bdc7bc6',
          percentile: 94.125,
          score: 166,
        },
        {
          _id: '673c75ef2621a3331bdc7bc7',
          percentile: 94,
          score: 165,
        },
        {
          _id: '673c75ef2621a3331bdc7bc8',
          percentile: 93.875,
          score: 164,
        },
        {
          _id: '673c75ef2621a3331bdc7bc9',
          percentile: 93.75,
          score: 163,
        },
        {
          _id: '673c75ef2621a3331bdc7bca',
          percentile: 93.625,
          score: 162,
        },
        {
          _id: '673c75ef2621a3331bdc7bcb',
          percentile: 93.5,
          score: 161,
        },
        {
          _id: '673c75ef2621a3331bdc7bcc',
          percentile: 93.375,
          score: 160,
        },
        {
          _id: '673c75ef2621a3331bdc7bcd',
          percentile: 93.25,
          score: 159,
        },
        {
          _id: '673c75ef2621a3331bdc7bce',
          percentile: 93.125,
          score: 158,
        },
        {
          _id: '673c75ef2621a3331bdc7bcf',
          percentile: 93,
          score: 157,
        },
        {
          _id: '673c75ef2621a3331bdc7bd0',
          percentile: 92.833333,
          score: 156,
        },
        {
          _id: '673c75ef2621a3331bdc7bd1',
          percentile: 92.666667,
          score: 155,
        },
        {
          _id: '673c75ef2621a3331bdc7bd2',
          percentile: 92.5,
          score: 154,
        },
        {
          _id: '673c75ef2621a3331bdc7bd3',
          percentile: 92.333333,
          score: 153,
        },
        {
          _id: '673c75ef2621a3331bdc7bd4',
          percentile: 92.166667,
          score: 152,
        },
        {
          _id: '673c75ef2621a3331bdc7bd5',
          percentile: 92,
          score: 151,
        },
        {
          _id: '673c75ef2621a3331bdc7bd6',
          percentile: 91.833333,
          score: 150,
        },
        {
          _id: '673c75ef2621a3331bdc7bd7',
          percentile: 91.666667,
          score: 149,
        },
        {
          _id: '673c75ef2621a3331bdc7bd8',
          percentile: 91.5,
          score: 148,
        },
        {
          _id: '673c75ef2621a3331bdc7bd9',
          percentile: 91.333333,
          score: 147,
        },
        {
          _id: '673c75ef2621a3331bdc7bda',
          percentile: 91.166667,
          score: 146,
        },
        {
          _id: '673c75ef2621a3331bdc7bdb',
          percentile: 91,
          score: 145,
        },
        {
          _id: '673c75ef2621a3331bdc7bdc',
          percentile: 90.833333,
          score: 144,
        },
        {
          _id: '673c75ef2621a3331bdc7bdd',
          percentile: 90.666667,
          score: 143,
        },
        {
          _id: '673c75ef2621a3331bdc7bde',
          percentile: 90.5,
          score: 142,
        },
        {
          _id: '673c75ef2621a3331bdc7bdf',
          percentile: 90.333333,
          score: 141,
        },
        {
          _id: '673c75ef2621a3331bdc7be0',
          percentile: 90.166667,
          score: 140,
        },
        {
          _id: '673c75ef2621a3331bdc7be1',
          percentile: 90,
          score: 139,
        },
      ],
      createdAt: '2024-11-19T16:56:39.111Z',
      updatedAt: '2024-11-19T16:56:39.111Z',
      __v: 0,
    },
    isAvailable: true,
    version: 1,
  },
  analysisVideo: '',
  detailAccessDate: '2024-07-01T03:30:00.000Z',
  analysisVideoCdn: 'vm',
  analysisAllowed: true,
  mode: 'normal',
  isStarted: true,
  isExpired: false,
  isAttempted: true,
  packTitle: 'JEE Main 2025 Full Test Series for Class 12 (July Batch)',
  userType: 'free',
  paymentLink:
    'https://pay.mathongo.com/?item_id=_Z5VOZ-Y2&coupon=CHAMPS25&utm_source=quizrr&utm_medium=packs_platform&utm_campaign=jee_main_2025_full_test_series_class_12_july',
  startDate: '2024-07-01T03:30:00.000Z',
  endDate: '2025-08-31T18:29:59.000Z',
  status: 'available',
  ctype: null,
  title: 'JEE Main Full Test',
  totalQuestions: 75,
  totalMarks: 300,
  bonusQuestions: null,
  bonusSections: [],
  bonusMarks: null,
  instruction: {
    _id: '608289ffb160b022e9442c83',
    title: 'JEE Main Instruction',
    instructions: [
      {
        _id: '60701540783231309cfb5fe9',
        position: 0,
        text: 'Instructions for JEE Main New Pattern',
      },
    ],
    createdAt: '2021-04-09T08:50:08.265Z',
    updatedAt: '2021-04-09T08:50:08.265Z',
    __v: 0,
  },
  totalTime: 180,
  basicAnalysis: {
    _id: '67370fa98e7e22fadb8ca3dc',
    isBonusAttempted: false,
    totalTimeTaken: 6768,
    totalMarkScored: 226,
    totalAttempted: 59,
    totalCorrect: 57,
    accuracy: 96.61016949152543,
    submittedAt: '2024-11-15T09:08:57.815Z',
  },
  packExpired: false,
  packVersion: 2,
  packSlug: 'jee-main-2025-full-test-series-for-class-12-july-batch',
  sections: [
    {
      _id: '667d30ed14e932e9dc100b89',
      sectionId: {
        _id: '671923ae6bc3007257f366ed',
        sectionType: 'normal',
        questions: [
          {
            _id: '667d30ec14e932e9dc1007bf',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007c4',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007c9',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007ce',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007d3',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007d8',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007dd',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007e2',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007e7',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007ec',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007f1',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007f6',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc1007fb',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100800',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100805',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10080a',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10080f',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100814',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100819',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10081e',
            type: 'singleCorrect',
          },
        ],
        title: 'Physics Single Correct',
        subject: '607018ee404ae53194e73d90',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 20,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.124Z',
        updatedAt: '2024-06-27T09:29:16.124Z',
        __v: 0,
      },
      position: 0,
    },
    {
      _id: '667d30ed14e932e9dc100b8a',
      sectionId: {
        _id: '671923ae6bc3007257f366ee',
        sectionType: 'normal',
        questions: [
          {
            _id: '667d30ec14e932e9dc100878',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc100882',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc100887',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc10088c',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc100896',
            type: 'numerical',
          },
        ],
        title: 'Physics Numerical',
        subject: '607018ee404ae53194e73d90',
        markingScheme: {
          _id: '608283c623cf4b3ad8f125e5',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 5,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.275Z',
        updatedAt: '2024-06-27T09:29:16.275Z',
        __v: 0,
      },
      position: 1,
    },
    {
      _id: '667d30ed14e932e9dc100b8b',
      sectionId: {
        _id: '671923ae6bc3007257f366ef',
        sectionType: 'normal',
        questions: [
          {
            _id: '667d30ec14e932e9dc100931',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100936',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10093b',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100940',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100945',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10094a',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10094f',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100954',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100959',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10095e',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100963',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100968',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10096d',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100972',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100977',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10097c',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100981',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100986',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc10098b',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ec14e932e9dc100990',
            type: 'singleCorrect',
          },
        ],
        title: 'Chemistry Single Correct',
        subject: '607018ee404ae53194e73d91',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 20,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.692Z',
        updatedAt: '2024-06-27T09:29:16.692Z',
        __v: 0,
      },
      position: 2,
    },
    {
      _id: '667d30ed14e932e9dc100b8c',
      sectionId: {
        _id: '671923ae6bc3007257f366f0',
        sectionType: 'normal',
        questions: [
          {
            _id: '667d30ec14e932e9dc1009e5',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc1009ef',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc1009f9',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc1009fe',
            type: 'numerical',
          },
          {
            _id: '667d30ec14e932e9dc100a0d',
            type: 'numerical',
          },
        ],
        title: 'Chemistry Numerical',
        subject: '607018ee404ae53194e73d91',
        markingScheme: {
          _id: '608283c623cf4b3ad8f125e5',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 5,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.862Z',
        updatedAt: '2024-06-27T09:29:16.862Z',
        __v: 0,
      },
      position: 3,
    },
    {
      _id: '667d30ed14e932e9dc100b8d',
      sectionId: {
        _id: '671923af6bc3007257f366f1',
        sectionType: 'normal',
        questions: [
          {
            _id: '667d30ed14e932e9dc100aa3',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100aa8',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100aad',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ab2',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ab7',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100abc',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ac1',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ac6',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100acb',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ad0',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ad5',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ada',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100adf',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ae4',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100ae9',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100aee',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100af3',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100af8',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100afd',
            type: 'singleCorrect',
          },
          {
            _id: '667d30ed14e932e9dc100b02',
            type: 'singleCorrect',
          },
        ],
        title: 'Mathematics Single Correct',
        subject: '607018ee404ae53194e73d92',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 20,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:17.179Z',
        updatedAt: '2024-06-27T09:29:17.179Z',
        __v: 0,
      },
      position: 4,
    },
    {
      _id: '667d30ed14e932e9dc100b8e',
      sectionId: {
        _id: '671923af6bc3007257f366f2',
        sectionType: 'normal',
        questions: [
          {
            _id: '667d30ed14e932e9dc100b57',
            type: 'numerical',
          },
          {
            _id: '667d30ed14e932e9dc100b5c',
            type: 'numerical',
          },
          {
            _id: '667d30ed14e932e9dc100b61',
            type: 'numerical',
          },
          {
            _id: '667d30ed14e932e9dc100b6b',
            type: 'numerical',
          },
          {
            _id: '667d30ed14e932e9dc100b7f',
            type: 'numerical',
          },
        ],
        title: 'Mathematics Numerical',
        subject: '607018ee404ae53194e73d92',
        markingScheme: {
          _id: '608283c623cf4b3ad8f125e5',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 5,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:17.346Z',
        updatedAt: '2024-06-27T09:29:17.346Z',
        __v: 0,
      },
      position: 5,
    },
  ],
  subjects: [
    {
      _id: '667d30ed14e932e9dc100b8f',
      totalMarks: 100,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 30,
      subjectId: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b90',
      totalMarks: 100,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 30,
      subjectId: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b91',
      totalMarks: 100,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 30,
      subjectId: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
    },
  ],
  chapters: [
    {
      _id: '60e2fadb66f9ce3f243b4799',
      title: 'Motion In One Dimension',
    },
    {
      _id: '60c9e849ea076dc381c0dfab',
      title: 'Mechanical Properties of Fluids',
    },
    {
      _id: '60c9e849ea076dc381c0dfaa',
      title: 'Work Power Energy',
    },
    {
      _id: '60da9b5062f042332c538358',
      title: 'Ray Optics',
    },
    {
      _id: '60d2d1d2185d7a32fa3205ac',
      title: 'Atomic Physics',
    },
    {
      _id: '60ced3330e34b73944ddfadf',
      title: 'Electromagnetic Induction',
    },
    {
      _id: '60c9e849ea076dc381c0df7b',
      title: 'Center of Mass Momentum and Collision',
    },
    {
      _id: '60ced3330e34b73944ddfadc',
      title: 'Magnetic Effects of Current',
    },
    {
      _id: '60e2fb5866f9ce3f243b4f4d',
      title: 'Electromagnetic Waves',
    },
    {
      _id: '60e2fadb66f9ce3f243b4798',
      title: 'Semiconductors',
    },
    {
      _id: '60e08408faa0944a2c3d490b',
      title: 'Thermodynamics',
    },
    {
      _id: '60ced3330e34b73944ddfae6',
      title: 'Electrostatics',
    },
    {
      _id: '6117b60e478ae845c43c64ba',
      title: 'Experimental Physics',
    },
    {
      _id: '60c9e849ea076dc381c0dfb0',
      title: 'Gravitation',
    },
    {
      _id: '60c9e849ea076dc381c0dfa6',
      title: 'Laws of Motion',
    },
    {
      _id: '60ced3330e34b73944ddfade',
      title: 'Current Electricity',
    },
    {
      _id: '60e08408faa0944a2c3d490c',
      title: 'Kinetic Theory of Gases',
    },
    {
      _id: '60e2fb2066f9ce3f243b4b86',
      title: 'Units and Dimensions',
    },
    {
      _id: '60ced3330e34b73944ddfae3',
      title: 'Capacitance',
    },
    {
      _id: '60d2d1d2185d7a32fa3205a7',
      title: 'Nuclear Physics',
    },
    {
      _id: '60e2fadb66f9ce3f243b479a',
      title: 'Oscillations',
    },
    {
      _id: '60c9e849ea076dc381c0dfa9',
      title: 'Mechanical Properties of Solids',
    },
    {
      _id: '60c9e849ea076dc381c0df82',
      title: 'Rotational Motion',
    },
    {
      _id: '60d2d1d2185d7a32fa3205ae',
      title: 'Chemical Bonding and Molecular Structure',
    },
    {
      _id: '60d2d1d2185d7a32fa3205c0',
      title: 'd and f Block Elements',
    },
    {
      _id: '60c9e849ea076dc381c0dfb1',
      title: 'Structure of Atom',
    },
    {
      _id: '60ced3330e34b73944ddfaf4',
      title: 'General Organic Chemistry',
    },
    {
      _id: '60d2d1d2185d7a32fa3205b3',
      title: 'p Block Elements (Group 13 & 14)',
    },
    {
      _id: '60d2d1d2185d7a32fa3205bb',
      title: 'Coordination Compounds',
    },
    {
      _id: '60ced5dd19d2aa2b78a3a78c',
      title: 'Biomolecules',
    },
    {
      _id: '60c9e849ea076dc381c0df89',
      title: 'Ionic Equilibrium',
    },
    {
      _id: '60e2fadb66f9ce3f243b4797',
      title: 'p Block Elements (Group 15, 16, 17 & 18)',
    },
    {
      _id: '60c9e849ea076dc381c0df97',
      title: 'Solutions',
    },
    {
      _id: '60ced3330e34b73944ddfaf3',
      title: 'Haloalkanes and Haloarenes',
    },
    {
      _id: '60ced3330e34b73944ddfae9',
      title: 'Alcohols Phenols and Ethers',
    },
    {
      _id: '60ced3330e34b73944ddfaf2',
      title: 'Hydrocarbons',
    },
    {
      _id: '60c9e849ea076dc381c0df91',
      title: 'Electrochemistry',
    },
    {
      _id: '60c9e849ea076dc381c0df8c',
      title: 'Thermodynamics (C)',
    },
    {
      _id: '60c9e849ea076dc381c0df92',
      title: 'Some Basic Concepts of Chemistry',
    },
    {
      _id: '60e2fadb66f9ce3f243b479d',
      title: 'Chemical Kinetics',
    },
    {
      _id: '60c9e849ea076dc381c0dfb6',
      title: 'Binomial Theorem',
    },
    {
      _id: '60da9b5062f042332c53835f',
      title: 'Differential Equations',
    },
    {
      _id: '60e2faad66f9ce3f243b456c',
      title: 'Sets and Relations',
    },
    {
      _id: '60c9e849ea076dc381c0dfb3',
      title: 'Complex Number',
    },
    {
      _id: '6162fc8f6ed13040ec85ba93',
      title: 'Three Dimensional Geometry',
    },
    {
      _id: '60c9e849ea076dc381c0df9d',
      title: 'Sequences and Series',
    },
    {
      _id: '60d2d1d2185d7a32fa3205cd',
      title: 'Parabola',
    },
    {
      _id: '60da9b5062f042332c538362',
      title: 'Definite Integration',
    },
    {
      _id: '60d2d1d2185d7a32fa32059c',
      title: 'Ellipse',
    },
    {
      _id: '60ced3330e34b73944ddfb02',
      title: 'Continuity and Differentiability',
    },
    {
      _id: '60e2faad66f9ce3f243b4573',
      title: 'Statistics',
    },
    {
      _id: '60e2faad66f9ce3f243b457a',
      title: 'Matrices',
    },
    {
      _id: '60e08408faa0944a2c3d4922',
      title: 'Vector Algebra',
    },
    {
      _id: '60ced3330e34b73944ddfb10',
      title: 'Limits',
    },
    {
      _id: '60d2d1d2185d7a32fa3205c6',
      title: 'Circle',
    },
    {
      _id: '60d2d1d2185d7a32fa3205bc',
      title: 'Straight Lines',
    },
    {
      _id: '60ced3330e34b73944ddfb0f',
      title: 'Functions',
    },
    {
      _id: '60c9e849ea076dc381c0df9c',
      title: 'Probability',
    },
    {
      _id: '60da9b5062f042332c538368',
      title: 'Differentiation',
    },
    {
      _id: '60da9b5062f042332c538365',
      title: 'Area Under Curves',
    },
    {
      _id: '60e08408faa0944a2c3d4927',
      title: 'Trigonometric Equations',
    },
  ],
  description: 'Previous Year Paper as Mock Test',
};

export const overviewMockData = {
  success: true,
  message: 'Analysis overview sent successfully',
  data: {
    tabsToShow: [
      'Overview',
      'Performance Analysis',
      'Time Analysis',
      'Attempt Analysis',
      'Difficulty Analysis',
      'Subject Movement',
      'Question Journey',
      'Qs by Qs Analysis',
    ],

    tabIconsMapping: {
      Overview: 'CheckerboardIcon',
      'Performance Analysis': 'ChartLineIcon',
      'Score Potential': 'WarningDiamondIcon',
      'Attempt Analysis': 'CheckSquareOffsetIcon',
      'Time Analysis': 'ClockIcon',
      'Difficulty Analysis': 'SpeedometerIcon',
      'Subject Movement': 'NyTimesLogoIcon',
      'Question Journey': 'LineSegmentsIcon',
      'Qs by Qs Analysis': 'ListNumbersIcon',
    },

    percentileObject: {
      calculatedPercentile: {
        title: null,
        data: '99.9+',
        subjectWisePercentile: [
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
              title: 'Math',
              color: '#0086FF',
              positiveScore: 80,
              negativeScore: 3,
              totalScore: 100,
              markScored: 77,
              timeTaken: 4435,
              accuracy: 86.96,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: null,
              data: '99.9',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
              title: 'Phy',
              color: '#37B24D',
              positiveScore: 92,
              negativeScore: 2,
              totalScore: 100,
              markScored: 90,
              timeTaken: 1959,
              accuracy: 92,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: null,
              data: '99.5',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
              title: 'Chem',
              color: '#FF8C33',
              positiveScore: 92,
              negativeScore: 1,
              totalScore: 100,
              markScored: 91,
              timeTaken: 2412,
              accuracy: 95.83,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: null,
              data: '99.9+',
            },
          },
        ],
      },
      percentileData: {
        consolationText: 'Below 90 isn’t final. Revise, Analyze and Come Back Stronger',
        description: 'This percentile calculation is done on the basis of JEE Main 2025 January attempt data.',
      },
      isAvailable: true,
      isProjected: false,
    },

    subjectWiseData: {
      '607018ee404ae53194e73d92': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Math',
        color: '#0086FF',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 100,
        markScored: 86,
        timeTaken: 6,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d90': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Phy',
        color: '#37B24D',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 100,
        markScored: 60,
        timeTaken: 0,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d91': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Chem',
        color: '#FF8C33',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 100,
        markScored: 80,
        timeTaken: 0,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
    },

    overallData: {
      markScored: 226,
      totalScore: 300,
      userRank: 77,
      totalRanks: 22019,
    },

    overview: {
      markScored: 226,
      totalScore: 300,
      questionAttempted: 59,
      totalQuestions: 75,
      accuracy: '96.61',
      timeTaken: 111,
      positiveScore: 228,
      marksLost: 2,
    },

    paidFeatures: [],
    paymentLink: '#',
  },

  showCutoff: false,
};

export const performanceAnalysisMockData = {
  success: true,
  message: 'Performance Analysis Sent Successfully',
  performance: {
    testPerformance: {
      physics: {
        markScored: 91,
        totalScore: 100,
      },
      chemistry: {
        markScored: 80,
        totalScore: 100,
      },
      mathematics: {
        markScored: 55,
        totalScore: 100,
      },
      overall: {
        markScored: 226,
        totalScore: 300,
      },
    },
    testBreakdown: {
      physics: {
        correct: 23,
        incorrect: 1,
        unattempted: 1,
        notVisited: 0,
        totalQuestions: 25,
      },
      chemistry: {
        correct: 20,
        incorrect: 0,
        unattempted: 5,
        notVisited: 0,
        totalQuestions: 25,
      },
      mathematics: {
        correct: 14,
        incorrect: 1,
        unattempted: 10,
        notVisited: 0,
        totalQuestions: 25,
      },
      overall: {
        correct: 57,
        incorrect: 2,
        unattempted: 16,
        notVisited: 0,
        totalQuestions: 75,
      },
    },
  },
  subjectMeta: {
    overall: {
      _id: 'overall',
      title: 'Overall',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
      color: '#364FC7',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    physics: {
      _id: '607018ee404ae53194e73d90',
      title: 'Physics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
      color: '#37B24D',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    chemistry: {
      _id: '607018ee404ae53194e73d91',
      title: 'Chemistry',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
      color: '#FF8C33',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
    },
    mathematics: {
      _id: '607018ee404ae53194e73d92',
      title: 'Mathematics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
      color: '#0086FF',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
    },
  },
};

export const timeAnalysisMockData = {
  success: true,
  message: 'Time and accuracy analysis sent successfully',
  data: {
    timeAndAccuracy: {
      overall: {
        timeSpent: 112,
        totalQuestions: 75,
        attemptQuestions: 59,
        accuracy: '96.61',
      },
      physics: {
        timeSpent: 28,
        totalQuestions: 25,
        attemptQuestions: 24,
        accuracy: '95.83',
      },
      chemistry: {
        timeSpent: 20,
        totalQuestions: 25,
        attemptQuestions: 20,
        accuracy: '100.00',
      },
      mathematics: {
        timeSpent: 63,
        totalQuestions: 25,
        attemptQuestions: 15,
        accuracy: '93.33',
      },
    },
    subjectMeta: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      mathematics: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        shortName: 'Math',
        color: '#0086FF',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
      },
    },
    qualityOfTime: {
      overall: {
        timeSpentCorrect: 79,
        timeSpentIncorrect: 2,
        timeSpentUnattempted: 30,
      },
      physics: {
        timeSpentCorrect: 26,
        timeSpentIncorrect: 0,
        timeSpentUnattempted: 1,
      },
      chemistry: {
        timeSpentCorrect: 17,
        timeSpentIncorrect: 0,
        timeSpentUnattempted: 3,
      },
      mathematics: {
        timeSpentCorrect: 36,
        timeSpentIncorrect: 1,
        timeSpentUnattempted: 24,
      },
    },
    timeJourney: {
      '0-30M': {
        correct: 23,
        incorrect: 1,
        overall: 24,
      },
      '30-60M': {
        correct: 20,
        incorrect: 1,
        overall: 21,
      },
      '60-90M': {
        correct: 7,
        incorrect: 0,
        overall: 7,
      },
      '90-120M': {
        correct: 7,
        incorrect: 0,
        overall: 7,
      },
      '120-150M': {
        correct: 0,
        incorrect: 0,
        overall: 0,
      },
      '150-180M': {
        correct: 0,
        incorrect: 0,
        overall: 0,
      },
    },
  },
};

export const attemptAnalysisMockData = {
  success: true,
  message: 'Quality attempt analysis sent successfully',
  data: {
    subjectData: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      mathematics: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        shortName: 'Math',
        color: '#0086FF',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
      },
    },
    overall: {
      perfect: 46,
      wasted: 0,
      overtime: 0,
      confused: 3,
    },
    physics: {
      perfect: 20,
      wasted: 0,
      overtime: 0,
      confused: 0,
    },
    chemistry: {
      perfect: 19,
      wasted: 0,
      overtime: 0,
      confused: 0,
    },
    mathematics: {
      perfect: 7,
      wasted: 0,
      overtime: 0,
      confused: 3,
    },
  },
};

export const difficultyAnalysisMockData = {
  data: {
    subjectMeta: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      mathematics: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        shortName: 'Math',
        color: '#0086FF',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
      },
    },
    overall: {
      easy: {
        correct: 24,
        incorrect: 0,
        notAttempted: 5,
        totalQuestions: 0,
      },
      moderate: {
        correct: 20,
        incorrect: 2,
        notAttempted: 9,
        totalQuestions: 0,
      },
      tough: {
        correct: 13,
        incorrect: 0,
        notAttempted: 2,
        totalQuestions: 0,
      },
    },
    physics: {
      easy: {
        correct: 12,
        incorrect: 0,
        notAttempted: 0,
      },
      moderate: {
        correct: 7,
        incorrect: 1,
        notAttempted: 1,
      },
      tough: {
        correct: 4,
        incorrect: 0,
        notAttempted: 0,
      },
    },
    chemistry: {
      easy: {
        correct: 6,
        incorrect: 0,
        notAttempted: 3,
      },
      moderate: {
        correct: 8,
        incorrect: 0,
        notAttempted: 1,
      },
      tough: {
        correct: 6,
        incorrect: 0,
        notAttempted: 1,
      },
    },
    mathematics: {
      easy: {
        correct: 6,
        incorrect: 0,
        notAttempted: 2,
      },
      moderate: {
        correct: 5,
        incorrect: 1,
        notAttempted: 7,
      },
      tough: {
        correct: 3,
        incorrect: 0,
        notAttempted: 1,
      },
    },
  },
};

export const subjectMovementTimelineMockData = {
  data: {
    success: true,
    message: 'Subject movement sent successfully!',
    journeyV2: [
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Started with Physics Single Correct',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 1231,
        relativeTimeStamp: 1731654480347,
        questionAttemptedBeforeSwitch: 0,
        isOpenedAgain: false,
        subjectName: 'Physics Single Correct',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Switched to Physics Numerical',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 734,
        relativeTimeStamp: 1731655728560,
        questionAttemptedBeforeSwitch: 21,
        isOpenedAgain: true,
        subjectName: 'Physics Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry Single Correct',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 789,
        relativeTimeStamp: 1731656293134,
        questionAttemptedBeforeSwitch: 3,
        isOpenedAgain: false,
        subjectName: 'Chemistry Single Correct',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry Numerical',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 353,
        relativeTimeStamp: 1731657097772,
        questionAttemptedBeforeSwitch: 15,
        isOpenedAgain: true,
        subjectName: 'Chemistry Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Switched to Mathematics Single Correct',
        color: '#0086FF',
        subjectId: '607018ee404ae53194e73d92',
        timeSpent: 3319,
        relativeTimeStamp: 1731657455116,
        questionAttemptedBeforeSwitch: 4,
        isOpenedAgain: false,
        subjectName: 'Mathematics Single Correct',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Switched to Mathematics Numerical',
        color: '#0086FF',
        subjectId: '607018ee404ae53194e73d92',
        timeSpent: 220,
        relativeTimeStamp: 1731660794979,
        questionAttemptedBeforeSwitch: 15,
        isOpenedAgain: true,
        subjectName: 'Mathematics Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Switched to Physics Single Correct',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 1338,
        relativeTimeStamp: 1731661019192,
        questionAttemptedBeforeSwitch: 0,
        isOpenedAgain: true,
        subjectName: 'Physics Single Correct',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Switched to Physics Numerical',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 596,
        relativeTimeStamp: 1731661225795,
        questionAttemptedBeforeSwitch: 20,
        isOpenedAgain: true,
        subjectName: 'Physics Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry Single Correct',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 850,
        relativeTimeStamp: 1731661269015,
        questionAttemptedBeforeSwitch: 4,
        isOpenedAgain: true,
        subjectName: 'Chemistry Single Correct',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry Numerical',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 374,
        relativeTimeStamp: 1731661346238,
        questionAttemptedBeforeSwitch: 16,
        isOpenedAgain: true,
        subjectName: 'Chemistry Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Switched to Physics Numerical',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 600,
        relativeTimeStamp: 1731661368014,
        questionAttemptedBeforeSwitch: 0,
        isOpenedAgain: true,
        subjectName: 'Physics Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry Numerical',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 392,
        relativeTimeStamp: 1731661373156,
        questionAttemptedBeforeSwitch: 0,
        isOpenedAgain: true,
        subjectName: 'Chemistry Numerical',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Switched to Mathematics Single Correct',
        color: '#0086FF',
        subjectId: '607018ee404ae53194e73d92',
        timeSpent: 3418,
        relativeTimeStamp: 1731661394616,
        questionAttemptedBeforeSwitch: 4,
        isOpenedAgain: true,
        subjectName: 'Mathematics Single Correct',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Switched to Mathematics Numerical',
        color: '#0086FF',
        subjectId: '607018ee404ae53194e73d92',
        timeSpent: 443,
        relativeTimeStamp: 1731661511330,
        questionAttemptedBeforeSwitch: 15,
        isOpenedAgain: true,
        subjectName: 'Mathematics Numerical',
      },
    ],
    isSingleSubjectTest: false,
  },
};

export const ErrorAnalysisMockData = {
  data: {
    errors: [
      {
        chapters: [
          {
            chapter: 'Magnetic Effects of Current',
            topics: [
              {
                topic: 'Motion of Charged Particle in Magnetic Field',
                answers: [
                  {
                    question: '667d30ec14e932e9dc1007ce',
                    status: 'answered',
                    questionNumber: 4,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Physics',
      },
      {
        chapters: [
          {
            chapter: 'Differential Equations',
            topics: [
              {
                topic: 'Variable Separable Form',
                answers: [
                  {
                    question: '667d30ed14e932e9dc100aad',
                    status: 'answered',
                    questionNumber: 53,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Mathematics',
      },
    ],
    scoreImprovement: [
      {
        subjectMeta: {
          _id: 'overall',
          title: 'Overall',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
          color: '#364FC7',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
        },
        improvement: [
          {
            reductionPercentage: 50,
            improvedScoreByErrorReduction: 231,
            actualScore: 226,
            maxScore: 300,
            moreCorrectCouldBe: 1,
          },
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 236,
            actualScore: 226,
            maxScore: 300,
            moreCorrectCouldBe: 2,
          },
        ],
        actual: {
          actualScore: 226,
          maxScore: 300,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d90',
          title: 'Physics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
          shortName: 'Phy',
          color: '#37B24D',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 96,
            actualScore: 91,
            maxScore: 100,
            moreCorrectCouldBe: 1,
          },
        ],
        actual: {
          actualScore: 91,
          maxScore: 100,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d91',
          title: 'Chemistry',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
          shortName: 'Chem',
          color: '#FF8C33',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
        },
        improvement: [],
        actual: {
          actualScore: 80,
          maxScore: 100,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d92',
          title: 'Mathematics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
          shortName: 'Math',
          color: '#0086FF',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 60,
            actualScore: 55,
            maxScore: 100,
            moreCorrectCouldBe: 1,
          },
        ],
        actual: {
          actualScore: 55,
          maxScore: 100,
        },
      },
    ],
  },
};

export const QuestionJourneyMockData = {
  data: {
    success: true,
    message: 'Question journey sent successfully!',
    data: [
      [
        {
          questionNumber: 1,
          questionId: '667d30ec14e932e9dc1007bf',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654480352,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '2f896f',
              optionNumber: 4,
              optionValue:
                '<p><math xmlns="http://www.w3.org/1998/Math/MathML"><mn>4</mn><mo>&#160;</mo><mi mathvariant="normal">m</mi><mo>&#160;</mo><msup><mi mathvariant="normal">s</mi><mrow><mo>-</mo><mn>1</mn></mrow></msup></math> in <math xmlns="http://www.w3.org/1998/Math/MathML"><mi>y</mi></math>-direction</p>',
            },
          ],
        },
        {
          questionNumber: 2,
          questionId: '667d30ec14e932e9dc1007c4',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654510350,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f17515',
              optionNumber: 2,
              optionValue: '<p>Statement I is incorrect but Statement II is correct</p>',
            },
          ],
        },
        {
          questionNumber: 3,
          questionId: '667d30ec14e932e9dc1007c9',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654546300,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '236672',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi>&#960;</mi><mo>-</mo><mn>2</mn><mo>&#160;</mo><mi mathvariant="normal">A</mi></math>',
            },
          ],
        },
        {
          questionNumber: 4,
          questionId: '667d30ec14e932e9dc1007ce',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654593320,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '28fd6c',
              optionNumber: 2,
              optionValue: '(A), (C) and (D) only',
            },
          ],
        },
        {
          questionNumber: 5,
          questionId: '667d30ec14e932e9dc1007d3',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654641239,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '45508b',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>4</mn><mi>g</mi></math>',
            },
          ],
        },
        {
          questionNumber: 6,
          questionId: '667d30ec14e932e9dc1007d8',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654678687,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'fd34ae',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>5</mn><mo>.</mo><mn>4</mn><mo>&#160;</mo><mi>cm</mi></math>',
            },
          ],
        },
        {
          questionNumber: 7,
          questionId: '667d30ec14e932e9dc1007dd',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654839190,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c1c903',
              optionNumber: 4,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/cfe98b54-2f84-4ac1-9729-0f2201cb97db.png" style="width: 263px; height: 81px;" />',
            },
          ],
        },
        {
          questionNumber: 8,
          questionId: '667d30ec14e932e9dc1007e2',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654869226,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '47d650',
              optionNumber: 2,
              optionValue: 'Specific rotation of liquids',
            },
          ],
        },
        {
          questionNumber: 9,
          questionId: '667d30ec14e932e9dc1007e7',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654884746,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '7bf942',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>2</mn><mo>:</mo><mn>5</mn></math>',
            },
          ],
        },
        {
          questionNumber: 10,
          questionId: '667d30ec14e932e9dc1007ec',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654919293,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '793e8d',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>284</mn><mo>&#160;</mo><mi mathvariant="normal">J</mi></math>',
            },
          ],
        },
        {
          questionNumber: 11,
          questionId: '667d30ec14e932e9dc1007f1',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655026133,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'b47413',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>16</mn><mn>9</mn></mfrac><mi>R</mi></math>',
            },
          ],
        },
        {
          questionNumber: 12,
          questionId: '667d30ec14e932e9dc1007f6',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655065724,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '79eff1',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>+</mo><mn>1</mn><mo>&#160;</mo><mi mathvariant="normal">V</mi></math>',
            },
          ],
        },
        {
          questionNumber: 13,
          questionId: '667d30ec14e932e9dc1007fb',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655159652,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '9ade96',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>0</mn><mo>&#160;</mo><mi mathvariant="normal">V</mi></math>',
            },
          ],
        },
        {
          questionNumber: 14,
          questionId: '667d30ec14e932e9dc100800',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655206534,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '68375b',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi>I</mi></math>',
            },
          ],
        },
        {
          questionNumber: 15,
          questionId: '667d30ec14e932e9dc100805',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655250525,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'cba067',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>5</mn></math>',
            },
          ],
        },
        {
          questionNumber: 16,
          questionId: '667d30ec14e932e9dc10080a',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655291838,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '97fcca',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>53</mn><mo>.</mo><mn>1</mn><mo>&#160;</mo><mi mathvariant="normal">W</mi><mo>&#160;</mo><msup><mi mathvariant="normal">m</mi><mrow><mo>-</mo><mn>2</mn></mrow></msup></math>',
            },
          ],
        },
        {
          questionNumber: 17,
          questionId: '667d30ec14e932e9dc10080f',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655436791,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'df5fa6',
              optionNumber: 1,
              optionValue: 'Statement I is true but Statement II is false',
            },
          ],
        },
        {
          questionNumber: 18,
          questionId: '667d30ec14e932e9dc100814',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655476394,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f4fec6',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>66</mn></math>',
            },
          ],
        },
        {
          questionNumber: 19,
          questionId: '667d30ec14e932e9dc100819',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655588309,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'e72c1f',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mi>R</mi><mn>25</mn></mfrac></math>',
            },
          ],
        },
        {
          questionNumber: 20,
          questionId: '667d30ec14e932e9dc10081e',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655614532,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'a53e0e',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>3200</mn><mo>&#160;</mo><mi mathvariant="normal">K</mi></math>',
            },
          ],
        },
        {
          questionNumber: 21,
          questionId: '667d30ec14e932e9dc100878',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655728560,
          inputValue: '2',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 22,
          questionId: '667d30ec14e932e9dc100882',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: true,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655891915,
          inputValue: null,
          questionType: 'numerical',
          selectedOptions: null,
        },
        {
          questionNumber: 21,
          questionId: '667d30ec14e932e9dc100878',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655906984,
          inputValue: '2',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 22,
          questionId: '667d30ec14e932e9dc100882',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731655915171,
          inputValue: '236',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 23,
          questionId: '667d30ec14e932e9dc100887',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656034634,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 24,
          questionId: '667d30ec14e932e9dc10088c',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656104469,
          inputValue: '12',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 25,
          questionId: '667d30ec14e932e9dc100896',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656197711,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
      ],
      [
        {
          questionNumber: 26,
          questionId: '667d30ec14e932e9dc100931',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656293134,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '7155cb',
              optionNumber: 1,
              optionValue: 'Phosphodiester linkage',
            },
          ],
        },
        {
          questionNumber: 27,
          questionId: '667d30ec14e932e9dc100936',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656303509,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'ffea09',
              optionNumber: 2,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/884cd34d-ba72-4e09-b2a1-70bdfa9814b0.png" style="width: 200px; height: 178px;" />',
            },
          ],
        },
        {
          questionNumber: 28,
          questionId: '667d30ec14e932e9dc10093b',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656327359,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 29,
          questionId: '667d30ec14e932e9dc100940',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656342844,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '39d61e',
              optionNumber: 4,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/ce0065ef-d752-4907-8545-6ca92fa26c6f.png" style="width: 120px; height: 185px;" />',
            },
          ],
        },
        {
          questionNumber: 30,
          questionId: '667d30ec14e932e9dc100945',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656373620,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '96066d',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>[</mo><mi>Ar</mi><mo>]</mo><mo>&#160;</mo><mn>3</mn><msup><mi mathvariant="normal">d</mi><mn>6</mn></msup></math>',
            },
          ],
        },
        {
          questionNumber: 31,
          questionId: '667d30ec14e932e9dc10094a',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656411011,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 32,
          questionId: '667d30ec14e932e9dc10094f',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656439913,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'b60295',
              optionNumber: 4,
              optionValue: 'decreased vapour pressure, increased boiling point',
            },
          ],
        },
        {
          questionNumber: 33,
          questionId: '667d30ec14e932e9dc100954',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656485826,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'a2a660',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi mathvariant="normal">Q</mi><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mi mathvariant="normal">R</mi><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mi mathvariant="normal">P</mi><mo>&#160;</mo></math>',
            },
          ],
        },
        {
          questionNumber: 34,
          questionId: '667d30ec14e932e9dc100959',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656630782,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'ef8990',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi>CHCl</mi><mn>3</mn></msub></math>',
            },
          ],
        },
        {
          questionNumber: 35,
          questionId: '667d30ec14e932e9dc10095e',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656657425,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'af6b22',
              optionNumber: 3,
              optionValue: 'Statement I is true but Statement II is false',
            },
          ],
        },
        {
          questionNumber: 36,
          questionId: '667d30ec14e932e9dc100963',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656723241,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 37,
          questionId: '667d30ec14e932e9dc100968',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656746741,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c5c150',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>(</mo><mi mathvariant="normal">A</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">C</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">D</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">B</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">E</mi><mo>)</mo></math>',
            },
          ],
        },
        {
          questionNumber: 38,
          questionId: '667d30ec14e932e9dc10096d',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656861269,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 39,
          questionId: '667d30ec14e932e9dc100972',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656881781,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '7f7aa6',
              optionNumber: 4,
              optionValue: 'Alicyclic',
            },
          ],
        },
        {
          questionNumber: 40,
          questionId: '667d30ec14e932e9dc100977',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656889274,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 41,
          questionId: '667d30ec14e932e9dc10097c',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656927937,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '11c971',
              optionNumber: 1,
              optionValue: 'Both Statement I and Statement II are correct',
            },
          ],
        },
        {
          questionNumber: 42,
          questionId: '667d30ec14e932e9dc100981',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656958855,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'df1540',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>3</mn><mo>-</mo><mi>Ethyl</mi><mo>-</mo><mn>1</mn><mo>,</mo><mn>1</mn><mo>-</mo><mi>dimethylcyclohexane</mi></math>',
            },
          ],
        },
        {
          questionNumber: 43,
          questionId: '667d30ec14e932e9dc100986',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656980951,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f6e56b',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi>CrO</mi><mn>2</mn></msub><msub><mi>Cl</mi><mn>2</mn></msub><mo>,</mo><mo>&#160;</mo><msub><mi>Na</mi><mn>2</mn></msub><msub><mi>CrO</mi><mn>4</mn></msub></math>',
            },
          ],
        },
        {
          questionNumber: 44,
          questionId: '667d30ec14e932e9dc10098b',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657039632,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '49a8e9',
              optionNumber: 4,
              optionValue:
                'Racemisation occurs in <math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi mathvariant="normal">S</mi><mi mathvariant="normal">N</mi></msub><mn>1</mn></math> reaction and inversion occurs in <math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi mathvariant="normal">S</mi><mi mathvariant="normal">N</mi></msub><mn>2</mn></math> reaction.&nbsp;',
            },
          ],
        },
        {
          questionNumber: 45,
          questionId: '667d30ec14e932e9dc100990',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657079382,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '1255ef',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>[</mo><mi>Xe</mi><mo>]</mo><mo>&#160;</mo><mn>4</mn><msup><mi mathvariant="normal">f</mi><mn>4</mn></msup><mo>&#160;</mo><mn>6</mn><msup><mi mathvariant="normal">s</mi><mn>2</mn></msup></math>',
            },
          ],
        },
        {
          questionNumber: 46,
          questionId: '667d30ec14e932e9dc1009e5',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657097772,
          inputValue: '2',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 47,
          questionId: '667d30ec14e932e9dc1009ef',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657174137,
          inputValue: '1200',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 48,
          questionId: '667d30ec14e932e9dc1009f9',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657273644,
          inputValue: '3',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 49,
          questionId: '667d30ec14e932e9dc1009fe',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657328599,
          inputValue: '4',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 50,
          questionId: '667d30ec14e932e9dc100a0d',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657362594,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 51,
          questionId: '667d30ed14e932e9dc100aa3',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657455116,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 52,
          questionId: '667d30ed14e932e9dc100aa8',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657489489,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 53,
          questionId: '667d30ed14e932e9dc100aad',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657664466,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '96677b',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi>log</mi><mfrac><mn>2</mn><mn>3</mn></mfrac></msub><mn>2</mn></math>',
            },
          ],
        },
        {
          questionNumber: 54,
          questionId: '667d30ed14e932e9dc100ab2',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657780532,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c9f745',
              optionNumber: 1,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>72</mn></math>',
            },
          ],
        },
        {
          questionNumber: 55,
          questionId: '667d30ed14e932e9dc100ab7',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731658034920,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '395724',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi mathvariant="normal">A</mi><mo>=</mo><msup><mi mathvariant="normal">B</mi><mn>3</mn></msup></math>',
            },
          ],
        },
      ],
      [
        {
          questionNumber: 56,
          questionId: '667d30ed14e932e9dc100abc',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731658099233,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '177c94',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>7</mn></math>',
            },
          ],
        },
        {
          questionNumber: 57,
          questionId: '667d30ed14e932e9dc100ac1',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731658260775,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '6ffb7d',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>20</mn></math>',
            },
          ],
        },
        {
          questionNumber: 58,
          questionId: '667d30ed14e932e9dc100ac6',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731658550444,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '470dbc',
              optionNumber: 2,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>8</mn></math>',
            },
          ],
        },
        {
          questionNumber: 59,
          questionId: '667d30ed14e932e9dc100acb',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731658751709,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '8987b6',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>8</mn></math>',
            },
          ],
        },
        {
          questionNumber: 60,
          questionId: '667d30ed14e932e9dc100ad0',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731659036867,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c7b48b',
              optionNumber: 4,
              optionValue: 'symmetric only',
            },
          ],
        },
        {
          questionNumber: 61,
          questionId: '667d30ed14e932e9dc100ad5',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731659055727,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'b58fe8',
              optionNumber: 1,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>1</mn></math>',
            },
          ],
        },
        {
          questionNumber: 62,
          questionId: '667d30ed14e932e9dc100ada',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731659090926,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '046118',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>5</mn><mn>13</mn></mfrac></math>',
            },
          ],
        },
        {
          questionNumber: 63,
          questionId: '667d30ed14e932e9dc100adf',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731659221333,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 64,
          questionId: '667d30ed14e932e9dc100ae4',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731659387288,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 65,
          questionId: '667d30ed14e932e9dc100ae9',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731659399361,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'bbb132',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><msqrt><mn>2009</mn></msqrt><mn>5</mn></mfrac></math>',
            },
          ],
        },
      ],
      [
        {
          questionNumber: 66,
          questionId: '667d30ed14e932e9dc100aee',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660102311,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '916d4e',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>30</mn><mn>41</mn></mfrac></math>',
            },
          ],
        },
        {
          questionNumber: 67,
          questionId: '667d30ed14e932e9dc100af3',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660392690,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '853763',
              optionNumber: 2,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>24</mn></math>',
            },
          ],
        },
        {
          questionNumber: 68,
          questionId: '667d30ed14e932e9dc100af8',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660463101,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '92ed4c',
              optionNumber: 2,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>32</mn></math>',
            },
          ],
        },
        {
          questionNumber: 69,
          questionId: '667d30ed14e932e9dc100afd',
          isCorrect: true,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660662143,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f2a441',
              optionNumber: 4,
              optionValue: 'Both Statement I and Statement II are true',
            },
          ],
        },
        {
          questionNumber: 70,
          questionId: '667d30ed14e932e9dc100b02',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660765676,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 71,
          questionId: '667d30ed14e932e9dc100b57',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660794979,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 72,
          questionId: '667d30ed14e932e9dc100b5c',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660805592,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 73,
          questionId: '667d30ed14e932e9dc100b61',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660830925,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 74,
          questionId: '667d30ed14e932e9dc100b6b',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660842935,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 75,
          questionId: '667d30ed14e932e9dc100b7f',
          isCorrect: false,
          timeVisited: 1,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660884113,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 1,
          questionId: '667d30ec14e932e9dc1007bf',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661019192,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '2f896f',
              optionNumber: 4,
              optionValue:
                '<p><math xmlns="http://www.w3.org/1998/Math/MathML"><mn>4</mn><mo>&#160;</mo><mi mathvariant="normal">m</mi><mo>&#160;</mo><msup><mi mathvariant="normal">s</mi><mrow><mo>-</mo><mn>1</mn></mrow></msup></math> in <math xmlns="http://www.w3.org/1998/Math/MathML"><mi>y</mi></math>-direction</p>',
            },
          ],
        },
        {
          questionNumber: 2,
          questionId: '667d30ec14e932e9dc1007c4',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661190857,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f17515',
              optionNumber: 2,
              optionValue: '<p>Statement I is incorrect but Statement II is correct</p>',
            },
          ],
        },
        {
          questionNumber: 3,
          questionId: '667d30ec14e932e9dc1007c9',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661192384,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '236672',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi>&#960;</mi><mo>-</mo><mn>2</mn><mo>&#160;</mo><mi mathvariant="normal">A</mi></math>',
            },
          ],
        },
        {
          questionNumber: 4,
          questionId: '667d30ec14e932e9dc1007ce',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661193915,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '28fd6c',
              optionNumber: 2,
              optionValue: '(A), (C) and (D) only',
            },
          ],
        },
        {
          questionNumber: 5,
          questionId: '667d30ec14e932e9dc1007d3',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661195516,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '45508b',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>4</mn><mi>g</mi></math>',
            },
          ],
        },
        {
          questionNumber: 6,
          questionId: '667d30ec14e932e9dc1007d8',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661196846,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'fd34ae',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>5</mn><mo>.</mo><mn>4</mn><mo>&#160;</mo><mi>cm</mi></math>',
            },
          ],
        },
        {
          questionNumber: 7,
          questionId: '667d30ec14e932e9dc1007dd',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661198096,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c1c903',
              optionNumber: 4,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/cfe98b54-2f84-4ac1-9729-0f2201cb97db.png" style="width: 263px; height: 81px;" />',
            },
          ],
        },
        {
          questionNumber: 8,
          questionId: '667d30ec14e932e9dc1007e2',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661199779,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '47d650',
              optionNumber: 2,
              optionValue: 'Specific rotation of liquids',
            },
          ],
        },
        {
          questionNumber: 9,
          questionId: '667d30ec14e932e9dc1007e7',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661200934,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '7bf942',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>2</mn><mo>:</mo><mn>5</mn></math>',
            },
          ],
        },
        {
          questionNumber: 10,
          questionId: '667d30ec14e932e9dc1007ec',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661202191,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '793e8d',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>284</mn><mo>&#160;</mo><mi mathvariant="normal">J</mi></math>',
            },
          ],
        },
        {
          questionNumber: 11,
          questionId: '667d30ec14e932e9dc1007f1',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661203755,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'b47413',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>16</mn><mn>9</mn></mfrac><mi>R</mi></math>',
            },
          ],
        },
        {
          questionNumber: 12,
          questionId: '667d30ec14e932e9dc1007f6',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661205093,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '79eff1',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>+</mo><mn>1</mn><mo>&#160;</mo><mi mathvariant="normal">V</mi></math>',
            },
          ],
        },
        {
          questionNumber: 13,
          questionId: '667d30ec14e932e9dc1007fb',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661206584,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '9ade96',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>0</mn><mo>&#160;</mo><mi mathvariant="normal">V</mi></math>',
            },
          ],
        },
        {
          questionNumber: 14,
          questionId: '667d30ec14e932e9dc100800',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661208586,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '68375b',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi>I</mi></math>',
            },
          ],
        },
        {
          questionNumber: 15,
          questionId: '667d30ec14e932e9dc100805',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661210791,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'cba067',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>5</mn></math>',
            },
          ],
        },
        {
          questionNumber: 16,
          questionId: '667d30ec14e932e9dc10080a',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661212189,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '97fcca',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>53</mn><mo>.</mo><mn>1</mn><mo>&#160;</mo><mi mathvariant="normal">W</mi><mo>&#160;</mo><msup><mi mathvariant="normal">m</mi><mrow><mo>-</mo><mn>2</mn></mrow></msup></math>',
            },
          ],
        },
        {
          questionNumber: 17,
          questionId: '667d30ec14e932e9dc10080f',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661214227,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'df5fa6',
              optionNumber: 1,
              optionValue: 'Statement I is true but Statement II is false',
            },
          ],
        },
        {
          questionNumber: 18,
          questionId: '667d30ec14e932e9dc100814',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661216406,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f4fec6',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>66</mn></math>',
            },
          ],
        },
        {
          questionNumber: 19,
          questionId: '667d30ec14e932e9dc100819',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661219762,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'e72c1f',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mi>R</mi><mn>25</mn></mfrac></math>',
            },
          ],
        },
        {
          questionNumber: 20,
          questionId: '667d30ec14e932e9dc10081e',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661223925,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'a53e0e',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>3200</mn><mo>&#160;</mo><mi mathvariant="normal">K</mi></math>',
            },
          ],
        },
        {
          questionNumber: 21,
          questionId: '667d30ec14e932e9dc100878',
          isCorrect: true,
          timeVisited: 3,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661225796,
          inputValue: '2',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 22,
          questionId: '667d30ec14e932e9dc100882',
          isCorrect: true,
          timeVisited: 3,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661233807,
          inputValue: '236',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 23,
          questionId: '667d30ec14e932e9dc100887',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661237976,
          inputValue: '16',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 24,
          questionId: '667d30ec14e932e9dc10088c',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661256063,
          inputValue: '12',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 25,
          questionId: '667d30ec14e932e9dc100896',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661264018,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 26,
          questionId: '667d30ec14e932e9dc100931',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661269015,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '7155cb',
              optionNumber: 1,
              optionValue: 'Phosphodiester linkage',
            },
          ],
        },
        {
          questionNumber: 27,
          questionId: '667d30ec14e932e9dc100936',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661272637,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'ffea09',
              optionNumber: 2,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/884cd34d-ba72-4e09-b2a1-70bdfa9814b0.png" style="width: 200px; height: 178px;" />',
            },
          ],
        },
        {
          questionNumber: 28,
          questionId: '667d30ec14e932e9dc10093b',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661274401,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 29,
          questionId: '667d30ec14e932e9dc100940',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661284938,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '39d61e',
              optionNumber: 4,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/ce0065ef-d752-4907-8545-6ca92fa26c6f.png" style="width: 120px; height: 185px;" />',
            },
          ],
        },
        {
          questionNumber: 30,
          questionId: '667d30ec14e932e9dc100945',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661288524,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '96066d',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>[</mo><mi>Ar</mi><mo>]</mo><mo>&#160;</mo><mn>3</mn><msup><mi mathvariant="normal">d</mi><mn>6</mn></msup></math>',
            },
          ],
        },
        {
          questionNumber: 31,
          questionId: '667d30ec14e932e9dc10094a',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661290313,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'cd3545',
              optionNumber: 4,
              optionValue:
                '<img src="https://cdn.quizrr.in/question-assets/jee_main_pyq/3880ae41-8fdb-4990-982c-6bb86af3de69.png" style="width: 400px; height: 119px;" />',
            },
          ],
        },
        {
          questionNumber: 32,
          questionId: '667d30ec14e932e9dc10094f',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661297480,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'b60295',
              optionNumber: 4,
              optionValue: 'decreased vapour pressure, increased boiling point',
            },
          ],
        },
        {
          questionNumber: 33,
          questionId: '667d30ec14e932e9dc100954',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661299876,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'a2a660',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi mathvariant="normal">Q</mi><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mi mathvariant="normal">R</mi><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mi mathvariant="normal">P</mi><mo>&#160;</mo></math>',
            },
          ],
        },
        {
          questionNumber: 34,
          questionId: '667d30ec14e932e9dc100959',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661302104,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'ef8990',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi>CHCl</mi><mn>3</mn></msub></math>',
            },
          ],
        },
        {
          questionNumber: 35,
          questionId: '667d30ec14e932e9dc10095e',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661303785,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'af6b22',
              optionNumber: 3,
              optionValue: 'Statement I is true but Statement II is false',
            },
          ],
        },
        {
          questionNumber: 36,
          questionId: '667d30ec14e932e9dc100963',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661307033,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 37,
          questionId: '667d30ec14e932e9dc100968',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661313390,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c5c150',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>(</mo><mi mathvariant="normal">A</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">C</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">D</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">B</mi><mo>)</mo><mo>&#160;</mo><mo>&#60;</mo><mo>&#160;</mo><mo>(</mo><mi mathvariant="normal">E</mi><mo>)</mo></math>',
            },
          ],
        },
        {
          questionNumber: 38,
          questionId: '667d30ec14e932e9dc10096d',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661318532,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 39,
          questionId: '667d30ec14e932e9dc100972',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661324960,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '7f7aa6',
              optionNumber: 4,
              optionValue: 'Alicyclic',
            },
          ],
        },
        {
          questionNumber: 40,
          questionId: '667d30ec14e932e9dc100977',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661326657,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 41,
          questionId: '667d30ec14e932e9dc10097c',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661329436,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '11c971',
              optionNumber: 1,
              optionValue: 'Both Statement I and Statement II are correct',
            },
          ],
        },
        {
          questionNumber: 42,
          questionId: '667d30ec14e932e9dc100981',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661335606,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'df1540',
              optionNumber: 2,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>3</mn><mo>-</mo><mi>Ethyl</mi><mo>-</mo><mn>1</mn><mo>,</mo><mn>1</mn><mo>-</mo><mi>dimethylcyclohexane</mi></math>',
            },
          ],
        },
        {
          questionNumber: 43,
          questionId: '667d30ec14e932e9dc100986',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661338956,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f6e56b',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi>CrO</mi><mn>2</mn></msub><msub><mi>Cl</mi><mn>2</mn></msub><mo>,</mo><mo>&#160;</mo><msub><mi>Na</mi><mn>2</mn></msub><msub><mi>CrO</mi><mn>4</mn></msub></math>',
            },
          ],
        },
        {
          questionNumber: 44,
          questionId: '667d30ec14e932e9dc10098b',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661341969,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '49a8e9',
              optionNumber: 4,
              optionValue:
                'Racemisation occurs in <math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi mathvariant="normal">S</mi><mi mathvariant="normal">N</mi></msub><mn>1</mn></math> reaction and inversion occurs in <math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi mathvariant="normal">S</mi><mi mathvariant="normal">N</mi></msub><mn>2</mn></math> reaction.&nbsp;',
            },
          ],
        },
        {
          questionNumber: 45,
          questionId: '667d30ec14e932e9dc100990',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661344080,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '1255ef',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mo>[</mo><mi>Xe</mi><mo>]</mo><mo>&#160;</mo><mn>4</mn><msup><mi mathvariant="normal">f</mi><mn>4</mn></msup><mo>&#160;</mo><mn>6</mn><msup><mi mathvariant="normal">s</mi><mn>2</mn></msup></math>',
            },
          ],
        },
        {
          questionNumber: 46,
          questionId: '667d30ec14e932e9dc1009e5',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661346238,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 21,
          questionId: '667d30ec14e932e9dc100878',
          isCorrect: false,
          timeVisited: 4,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661368014,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 46,
          questionId: '667d30ec14e932e9dc1009e5',
          isCorrect: true,
          timeVisited: 3,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661373156,
          inputValue: '2',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 47,
          questionId: '667d30ec14e932e9dc1009ef',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661381759,
          inputValue: '1200',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 48,
          questionId: '667d30ec14e932e9dc1009f9',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661385657,
          inputValue: '3',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 49,
          questionId: '667d30ec14e932e9dc1009fe',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661388270,
          inputValue: '4',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 50,
          questionId: '667d30ec14e932e9dc100a0d',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661391239,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 51,
          questionId: '667d30ed14e932e9dc100aa3',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661394616,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 52,
          questionId: '667d30ed14e932e9dc100aa8',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661398001,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 53,
          questionId: '667d30ed14e932e9dc100aad',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661401707,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '96677b',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><msub><mi>log</mi><mfrac><mn>2</mn><mn>3</mn></mfrac></msub><mn>2</mn></math>',
            },
          ],
        },
        {
          questionNumber: 54,
          questionId: '667d30ed14e932e9dc100ab2',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661404289,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c9f745',
              optionNumber: 1,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>72</mn></math>',
            },
          ],
        },
        {
          questionNumber: 55,
          questionId: '667d30ed14e932e9dc100ab7',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661408323,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '395724',
              optionNumber: 1,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mi mathvariant="normal">A</mi><mo>=</mo><msup><mi mathvariant="normal">B</mi><mn>3</mn></msup></math>',
            },
          ],
        },
        {
          questionNumber: 56,
          questionId: '667d30ed14e932e9dc100abc',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661410336,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '177c94',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>7</mn></math>',
            },
          ],
        },
        {
          questionNumber: 57,
          questionId: '667d30ed14e932e9dc100ac1',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661412708,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '6ffb7d',
              optionNumber: 3,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>20</mn></math>',
            },
          ],
        },
        {
          questionNumber: 58,
          questionId: '667d30ed14e932e9dc100ac6',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661416533,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '470dbc',
              optionNumber: 2,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>8</mn></math>',
            },
          ],
        },
        {
          questionNumber: 59,
          questionId: '667d30ed14e932e9dc100acb',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661418981,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '8987b6',
              optionNumber: 4,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>8</mn></math>',
            },
          ],
        },
        {
          questionNumber: 60,
          questionId: '667d30ed14e932e9dc100ad0',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661421497,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'c7b48b',
              optionNumber: 4,
              optionValue: 'symmetric only',
            },
          ],
        },
        {
          questionNumber: 61,
          questionId: '667d30ed14e932e9dc100ad5',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661425315,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'b58fe8',
              optionNumber: 1,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>1</mn></math>',
            },
          ],
        },
        {
          questionNumber: 62,
          questionId: '667d30ed14e932e9dc100ada',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661427693,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '046118',
              optionNumber: 3,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>5</mn><mn>13</mn></mfrac></math>',
            },
          ],
        },
        {
          questionNumber: 63,
          questionId: '667d30ed14e932e9dc100adf',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661429369,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 64,
          questionId: '667d30ed14e932e9dc100ae4',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661443781,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 65,
          questionId: '667d30ed14e932e9dc100ae9',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661446085,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [],
        },
        {
          questionNumber: 66,
          questionId: '667d30ed14e932e9dc100aee',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661454643,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '916d4e',
              optionNumber: 4,
              optionValue:
                '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>30</mn><mn>41</mn></mfrac></math>',
            },
          ],
        },
        {
          questionNumber: 67,
          questionId: '667d30ed14e932e9dc100af3',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661458930,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '853763',
              optionNumber: 2,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>24</mn></math>',
            },
          ],
        },
        {
          questionNumber: 68,
          questionId: '667d30ed14e932e9dc100af8',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661466277,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '92ed4c',
              optionNumber: 2,
              optionValue: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mn>32</mn></math>',
            },
          ],
        },
        {
          questionNumber: 69,
          questionId: '667d30ed14e932e9dc100afd',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661469684,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: 'f2a441',
              optionNumber: 4,
              optionValue: 'Both Statement I and Statement II are true',
            },
          ],
        },
        {
          questionNumber: 70,
          questionId: '667d30ed14e932e9dc100b02',
          isCorrect: true,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661474073,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions: [
            {
              optionId: '4c3164',
              optionNumber: 4,
              optionValue: 'neither one-one nor onto',
            },
          ],
        },
        {
          questionNumber: 71,
          questionId: '667d30ed14e932e9dc100b57',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661511330,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 72,
          questionId: '667d30ed14e932e9dc100b5c',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661524410,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 73,
          questionId: '667d30ed14e932e9dc100b61',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661611457,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 74,
          questionId: '667d30ed14e932e9dc100b6b',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: false,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661637329,
          inputValue: '',
          questionType: 'numerical',
          selectedOptions: [],
        },
        {
          questionNumber: 75,
          questionId: '667d30ed14e932e9dc100b7f',
          isCorrect: false,
          timeVisited: 2,
          isSkipped: true,
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731661642123,
          inputValue: null,
          questionType: 'numerical',
          selectedOptions: null,
        },
      ],
    ],
  },
};

export const AllQuestionsAnalysisMockData = {
  data: {
    data: {
      allQuestionsAnalysis: [
        {
          subject: 'Physics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
          color: '#37B24D',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
          types: [
            {
              type: 'singleCorrect',
              answers: [
                {
                  question: '667d30ec14e932e9dc1007bf',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 1,
                },
                {
                  question: '667d30ec14e932e9dc1007c4',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 2,
                },
                {
                  question: '667d30ec14e932e9dc1007c9',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 3,
                },
                {
                  question: '667d30ec14e932e9dc1007ce',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 4,
                },
                {
                  question: '667d30ec14e932e9dc1007d3',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 5,
                },
                {
                  question: '667d30ec14e932e9dc1007d8',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 6,
                },
                {
                  question: '667d30ec14e932e9dc1007dd',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 7,
                },
                {
                  question: '667d30ec14e932e9dc1007e2',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 8,
                },
                {
                  question: '667d30ec14e932e9dc1007e7',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 9,
                },
                {
                  question: '667d30ec14e932e9dc1007ec',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 10,
                },
                {
                  question: '667d30ec14e932e9dc1007f1',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 11,
                },
                {
                  question: '667d30ec14e932e9dc1007f6',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 12,
                },
                {
                  question: '667d30ec14e932e9dc1007fb',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 13,
                },
                {
                  question: '667d30ec14e932e9dc100800',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 14,
                },
                {
                  question: '667d30ec14e932e9dc100805',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 15,
                },
                {
                  question: '667d30ec14e932e9dc10080a',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 16,
                },
                {
                  question: '667d30ec14e932e9dc10080f',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 17,
                },
                {
                  question: '667d30ec14e932e9dc100814',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 18,
                },
                {
                  question: '667d30ec14e932e9dc100819',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 19,
                },
                {
                  question: '667d30ec14e932e9dc10081e',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 20,
                },
              ],
            },
            {
              type: 'numerical',
              answers: [
                {
                  question: '667d30ec14e932e9dc100878',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 4,
                  questionNumber: 21,
                },
                {
                  question: '667d30ec14e932e9dc100882',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 3,
                  questionNumber: 22,
                },
                {
                  question: '667d30ec14e932e9dc100887',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 23,
                },
                {
                  question: '667d30ec14e932e9dc10088c',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 24,
                },
                {
                  question: '667d30ec14e932e9dc100896',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 25,
                },
              ],
            },
          ],
        },
        {
          subject: 'Chemistry',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
          color: '#FF8C33',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
          types: [
            {
              type: 'singleCorrect',
              answers: [
                {
                  question: '667d30ec14e932e9dc100931',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 26,
                },
                {
                  question: '667d30ec14e932e9dc100936',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 27,
                },
                {
                  question: '667d30ec14e932e9dc10093b',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 28,
                },
                {
                  question: '667d30ec14e932e9dc100940',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 29,
                },
                {
                  question: '667d30ec14e932e9dc100945',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 30,
                },
                {
                  question: '667d30ec14e932e9dc10094a',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 31,
                },
                {
                  question: '667d30ec14e932e9dc10094f',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 32,
                },
                {
                  question: '667d30ec14e932e9dc100954',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 33,
                },
                {
                  question: '667d30ec14e932e9dc100959',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 34,
                },
                {
                  question: '667d30ec14e932e9dc10095e',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 35,
                },
                {
                  question: '667d30ec14e932e9dc100963',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 36,
                },
                {
                  question: '667d30ec14e932e9dc100968',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 37,
                },
                {
                  question: '667d30ec14e932e9dc10096d',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 38,
                },
                {
                  question: '667d30ec14e932e9dc100972',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 39,
                },
                {
                  question: '667d30ec14e932e9dc100977',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 40,
                },
                {
                  question: '667d30ec14e932e9dc10097c',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 41,
                },
                {
                  question: '667d30ec14e932e9dc100981',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 42,
                },
                {
                  question: '667d30ec14e932e9dc100986',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 43,
                },
                {
                  question: '667d30ec14e932e9dc10098b',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 44,
                },
                {
                  question: '667d30ec14e932e9dc100990',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 45,
                },
              ],
            },
            {
              type: 'numerical',
              answers: [
                {
                  question: '667d30ec14e932e9dc1009e5',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 3,
                  questionNumber: 46,
                },
                {
                  question: '667d30ec14e932e9dc1009ef',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 47,
                },
                {
                  question: '667d30ec14e932e9dc1009f9',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 48,
                },
                {
                  question: '667d30ec14e932e9dc1009fe',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 49,
                },
                {
                  question: '667d30ec14e932e9dc100a0d',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 50,
                },
              ],
            },
          ],
        },
        {
          subject: 'Mathematics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
          color: '#0086FF',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
          types: [
            {
              type: 'singleCorrect',
              answers: [
                {
                  question: '667d30ed14e932e9dc100aa3',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 51,
                },
                {
                  question: '667d30ed14e932e9dc100aa8',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 52,
                },
                {
                  question: '667d30ed14e932e9dc100aad',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 53,
                },
                {
                  question: '667d30ed14e932e9dc100ab2',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 54,
                },
                {
                  question: '667d30ed14e932e9dc100ab7',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 55,
                },
                {
                  question: '667d30ed14e932e9dc100abc',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 56,
                },
                {
                  question: '667d30ed14e932e9dc100ac1',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 57,
                },
                {
                  question: '667d30ed14e932e9dc100ac6',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 58,
                },
                {
                  question: '667d30ed14e932e9dc100acb',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 59,
                },
                {
                  question: '667d30ed14e932e9dc100ad0',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 60,
                },
                {
                  question: '667d30ed14e932e9dc100ad5',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 61,
                },
                {
                  question: '667d30ed14e932e9dc100ada',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 62,
                },
                {
                  question: '667d30ed14e932e9dc100adf',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 63,
                },
                {
                  question: '667d30ed14e932e9dc100ae4',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 64,
                },
                {
                  question: '667d30ed14e932e9dc100ae9',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 65,
                },
                {
                  question: '667d30ed14e932e9dc100aee',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 66,
                },
                {
                  question: '667d30ed14e932e9dc100af3',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 67,
                },
                {
                  question: '667d30ed14e932e9dc100af8',
                  status: 'answered',
                  isCorrect: false,
                  isPainful: true,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 68,
                },
                {
                  question: '667d30ed14e932e9dc100afd',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 69,
                },
                {
                  question: '667d30ed14e932e9dc100b02',
                  status: 'answered',
                  isCorrect: true,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 70,
                },
              ],
            },
            {
              type: 'numerical',
              answers: [
                {
                  question: '667d30ed14e932e9dc100b57',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 71,
                },
                {
                  question: '667d30ed14e932e9dc100b5c',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 72,
                },
                {
                  question: '667d30ed14e932e9dc100b61',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 73,
                },
                {
                  question: '667d30ed14e932e9dc100b6b',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 74,
                },
                {
                  question: '667d30ed14e932e9dc100b7f',
                  status: 'notAnswered',
                  isCorrect: false,
                  isPainful: false,
                  isImportant: false,
                  isMarkedForReview: false,
                  timesVisited: 2,
                  questionNumber: 75,
                },
              ],
            },
          ],
        },
      ],
      allQuestionsDetailedAnalysis: [
        {
          _id: '667d30ec14e932e9dc1007bf',
          chapter: 'Motion In One Dimension',
          topics: 'Rest and Motion',
          concept: 'Average Velocity',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 119,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007c4',
          chapter: 'Mechanical Properties of Fluids',
          topics: 'Viscosity',
          concept: 'Viscosity',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 36,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007c9',
          chapter: 'Ray Optics',
          topics: 'Prism and Dispersion of Light',
          concept: 'Condition of minimum deviation',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 47,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007ce',
          chapter: 'Magnetic Effects of Current',
          topics: 'Motion of Charged Particle in Magnetic Field',
          concept: 'Force on charged particle in Magnetic Field',
          level: 2,
          approximateTimeRequired: 90,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 48,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007d3',
          chapter: 'Gravitation',
          topics: 'Acceleration Due to Gravity',
          concept: 'variation of value of g at depth from surface',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 37,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007d8',
          chapter: 'Laws of Motion',
          topics: 'Non-uniform Circular Motion',
          concept: 'Dynamics of Circular Motion',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 160,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007dd',
          chapter: 'Semiconductors',
          topics: 'Diodes',
          concept: 'Forward and Reverse Biased Diode',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 30,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007e2',
          chapter: 'Experimental Physics',
          topics: 'Experimental Physics',
          concept: 'Experimental Physics',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 15,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007e7',
          chapter: 'Work Power Energy',
          topics: 'Energy',
          concept: 'Kinetic energy',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 34,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007ec',
          chapter: 'Thermodynamics',
          topics: 'First Law of Thermodynamics',
          concept: 'Intenal Energy',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 107,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007f1',
          chapter: 'Atomic Physics',
          topics: "Bohr's Atomic Model",
          concept: 'Radius of Nth Bohr orbit',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 40,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007f6',
          chapter: 'Electromagnetic Induction',
          topics: 'Induced Electric Field',
          concept: 'Induced Electric Field',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 94,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc1007fb',
          chapter: 'Electrostatics',
          topics: 'Electric Potential and Potential Energy',
          concept: 'Electric potential due to point charge',
          level: 3,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 47,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100800',
          chapter: 'Ray Optics',
          topics: 'Lens Formula, Refraction of light from curved surface',
          concept: 'Combination Of Lens',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 44,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100805',
          chapter: 'Center of Mass Momentum and Collision',
          topics: 'momentum',
          concept: 'Conservation of linear momentum',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 41,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc10080a',
          chapter: 'Electromagnetic Waves',
          topics: "Electromagnetic Waves and Maxwell's equations",
          concept: 'Properties of EM Waves',
          level: 3,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 145,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc10080f',
          chapter: 'Units and Dimensions',
          topics: 'Dimensions',
          concept: 'Dimensional formulae',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 40,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100814',
          chapter: 'Current Electricity',
          topics: 'Wheatstone Bridge',
          concept: 'Meter bridge',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 113,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100819',
          chapter: 'Current Electricity',
          topics: 'Resistance and Resistivity',
          concept: 'Resistance',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 28,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc10081e',
          chapter: 'Kinetic Theory of Gases',
          topics: 'Pressure and Energy of gas',
          concept: 'Kinetic Energy',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 114,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100878',
          chapter: 'Electromagnetic Induction',
          topics: 'Self and Mutual Inductance',
          concept: 'Mutual Inductance',
          level: 3,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 31,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100882',
          chapter: 'Nuclear Physics',
          topics: 'Nuclear energy',
          concept: 'Binding energy per nucleon',
          level: 3,
          approximateTimeRequired: 180,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 136,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100887',
          chapter: 'Rotational Motion',
          topics: 'Moment of inertia of rigid bodies',
          concept: 'Perpendicular axis theorem',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 23,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc10088c',
          chapter: 'Oscillations',
          topics: 'Simple Harmonic Motion',
          concept: 'Amplitude of SHM',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 99,
          status: 'answered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100896',
          chapter: 'Capacitance',
          topics: 'Charging and Discarging of capacitors',
          concept: 'Charging of Capacitors',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 99,
          status: 'notAnswered',
          subject: 'Physics',
        },
        {
          _id: '667d30ec14e932e9dc100931',
          chapter: 'Biomolecules',
          topics: 'Nucleic Acids',
          concept: 'DNA',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 13,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100936',
          chapter: 'General Organic Chemistry',
          topics: 'Isomerism of Organic Compounds',
          concept: 'Tautomerism',
          level: 3,
          approximateTimeRequired: 210,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 24,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10093b',
          chapter: 'p Block Elements (Group 15, 16, 17 & 18)',
          topics: 'Halogens and Its Compounds',
          concept: 'Preparation and Properties of Fluorine',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 25,
          status: 'notAnswered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100940',
          chapter: 'Ionic Equilibrium',
          topics: 'Theories of Acids and Bases',
          concept: 'Bronsted Lowry theory',
          level: 3,
          approximateTimeRequired: 180,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 33,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100945',
          chapter: 'Structure of Atom',
          topics: 'Quantum mechanical model',
          concept: 'Spin magnetic moment',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 38,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10094a',
          chapter: 'General Organic Chemistry',
          topics: 'Electron displacement effects',
          concept: 'Hyperconjugation effect',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 34,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10094f',
          chapter: 'Solutions',
          topics: "Vapour pressure and raoult's law",
          concept: 'Non ideal solutions showing negative deviation',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 47,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100954',
          chapter: 'Coordination Compounds',
          topics: "Werner's theory and Valence Bond Theory",
          concept: 'Paramagnetism and Diamagnetism',
          level: 3,
          approximateTimeRequired: 180,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 145,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100959',
          chapter: 'Chemical Bonding and Molecular Structure',
          topics: 'Polarization',
          concept: "Fajan's rule",
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 27,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10095e',
          chapter: 'd and f Block Elements',
          topics: 'F-Block elements',
          concept: 'Position in periodic table',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 68,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100963',
          chapter: 'Alcohols Phenols and Ethers',
          topics: 'Reactions of Alcohols',
          concept: 'Lucas test',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 29,
          status: 'notAnswered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100968',
          chapter: 'General Organic Chemistry',
          topics: 'Electron displacement effects',
          concept: 'Mesomeric effect',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 118,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10096d',
          chapter: 'p Block Elements (Group 13 & 14)',
          topics: 'Boron and Its Compounds',
          concept: 'Reactions of Boron',
          level: 3,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 26,
          status: 'notAnswered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100972',
          chapter: 'General Organic Chemistry',
          topics: 'Classification of organic compounds',
          concept: 'Classification of organic compounds',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 8,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100977',
          chapter: 'Coordination Compounds',
          topics: 'Terminology of coordination compounds',
          concept: 'Coordination compounds and complex ions',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 39,
          status: 'notAnswered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10097c',
          chapter: 'Ionic Equilibrium',
          topics: 'Theories of Acids and Bases',
          concept: 'Behaviour of acids and bases in aqueous solution',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 35,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100981',
          chapter: 'General Organic Chemistry',
          topics: 'IUPAC Nomenclature',
          concept: 'Saturated branched chain hydrocarbons',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 23,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100986',
          chapter: 'd and f Block Elements',
          topics: 'Compounds of Transition Metals',
          concept: 'Chromyl Chloride Test',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 60,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc10098b',
          chapter: 'Haloalkanes and Haloarenes',
          topics: 'Preparation and Properties of Monohalides',
          concept: 'Nucleophilic substitution reaction',
          level: 3,
          approximateTimeRequired: 210,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 40,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100990',
          chapter: 'Structure of Atom',
          topics: 'Electronic configuration',
          concept: 'Aufbau principle',
          level: 1,
          approximateTimeRequired: 60,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 18,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc1009e5',
          chapter: 'Chemical Kinetics',
          topics: 'Rate law and rate constant',
          concept: 'Order of reaction',
          level: 1,
          approximateTimeRequired: 90,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 105,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc1009ef',
          chapter: 'Thermodynamics (C)',
          topics: 'First Law and Basic Fundamentals of Thermodynamics',
          concept: 'Isothermal process',
          level: 3,
          approximateTimeRequired: 210,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 102,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc1009f9',
          chapter: 'General Organic Chemistry',
          topics: 'Conjugation and Aromaticity',
          concept: 'Huckel rule',
          level: 3,
          approximateTimeRequired: 240,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 56,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc1009fe',
          chapter: 'General Organic Chemistry',
          topics: 'Electron displacement effects',
          concept: 'Mesomeric effect',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 35,
          status: 'answered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ec14e932e9dc100a0d',
          chapter: 'p Block Elements (Group 15, 16, 17 & 18)',
          topics: 'Sulphur and Its Compounds',
          concept: 'Preparation and Properties of Sulphuric Acid',
          level: 1,
          approximateTimeRequired: 120,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 95,
          status: 'notAnswered',
          subject: 'Chemistry',
        },
        {
          _id: '667d30ed14e932e9dc100aa3',
          chapter: 'Binomial Theorem',
          topics: 'Properties of Binomial Coefficients',
          concept: 'Properties of Binomial Coefficients',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 37,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100aa8',
          chapter: 'Three Dimensional Geometry',
          topics: 'Line in Space',
          concept: 'questions based on intersection of lines',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: 'confused',
          isCorrect: false,
          timeTaken: 177,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100aad',
          chapter: 'Differential Equations',
          topics: 'Variable Separable Form',
          concept: 'questions on direct variable separable form',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 117,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ab2',
          chapter: 'Definite Integration',
          topics: 'Definite Integration by Parts',
          concept: 'Definite Integration by Parts',
          level: 3,
          approximateTimeRequired: 240,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 256,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ab7',
          chapter: 'Binomial Theorem',
          topics: 'Sum of Series',
          concept: 'sum involving binomial coefficients',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 64,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100abc',
          chapter: 'Sequences and Series',
          topics: 'Arithmetic Progression',
          concept: 'properties of AP',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 161,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ac1',
          chapter: 'Parabola',
          topics: 'standard equation of parabola',
          concept: 'questions on basic properties of parabola',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 292,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ac6',
          chapter: 'Three Dimensional Geometry',
          topics: 'Line in Space',
          concept: 'Skew Lines - find the length of shortest distance',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 201,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100acb',
          chapter: 'Definite Integration',
          topics: 'Properties of Definite Integration',
          concept: 'Basic Integration',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 286,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ad0',
          chapter: 'Sets and Relations',
          topics: 'Questions on Symmetric Transitive and Reflexive Properties',
          concept: 'Questions on Symmetric Transitive and Reflexive Properties',
          level: 3,
          approximateTimeRequired: 180,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 21,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ad5',
          chapter: 'Complex Number',
          topics: 'Locus Based on Distance Formula',
          concept: 'Equation of Perpendicular Bisector',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 35,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ada',
          chapter: 'Circle',
          topics: 'Equation of Circle & its intercept',
          concept: 'equation of circle through three given points',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 131,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100adf',
          chapter: 'Continuity and Differentiability',
          topics: 'Continuity',
          concept: 'when f(x) is piecewise defined function',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 178,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ae4',
          chapter: 'Statistics',
          topics: 'Measures of Dispersion',
          concept: 'Standard Deviation',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 12,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100ae9',
          chapter: 'Ellipse',
          topics: 'Chord with given Middle Point',
          concept: 'equation of chord when its midpoint is given',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'confused',
          isCorrect: false,
          timeTaken: 709,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100aee',
          chapter: 'Straight Lines',
          topics: 'Angle between Lines',
          concept: 'angle between 2 lines',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 292,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100af3',
          chapter: 'Vector Algebra',
          topics: 'Product of 2 vectors',
          concept: 'Mixed Problems on dot and cross product',
          level: 3,
          approximateTimeRequired: 210,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 75,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100af8',
          chapter: 'Limits',
          topics: 'Algebraic and Rational Limits',
          concept: "using standard formula's",
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: true,
          timeTaken: 200,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100afd',
          chapter: 'Matrices',
          topics: 'Inverse of a Matrix',
          concept: 'finding inverse using basic definition',
          level: 2,
          approximateTimeRequired: 120,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 107,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100b02',
          chapter: 'Functions',
          topics: 'Types of Function (Mapping)',
          concept: 'determining one one and onto',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: 'perfect',
          isCorrect: true,
          timeTaken: 65,
          status: 'answered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100b57',
          chapter: 'Differentiation',
          topics: 'Differentiation of composite functions',
          concept: 'questions',
          level: 2,
          approximateTimeRequired: 180,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 22,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100b5c',
          chapter: 'Differential Equations',
          topics: 'Homogeneous DE',
          concept: 'questions reducible to homogeneous form',
          level: 3,
          approximateTimeRequired: 210,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 110,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100b61',
          chapter: 'Area Under Curves',
          topics: 'Area bounded by two curves',
          concept: 'questions involving inequalities',
          level: 2,
          approximateTimeRequired: 210,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 36,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100b6b',
          chapter: 'Probability',
          topics: 'Conditional Probability and Multiplication Theorem',
          concept: 'question on conditional probability',
          level: 2,
          approximateTimeRequired: 150,
          attemptOverview: '',
          isCorrect: false,
          timeTaken: 44,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
        {
          _id: '667d30ed14e932e9dc100b7f',
          chapter: 'Complex Number',
          topics: 'Cube Root of Unity',
          concept: 'Cube Root of Unity',
          level: 1,
          approximateTimeRequired: 150,
          attemptOverview: 'confused',
          isCorrect: false,
          timeTaken: 170,
          status: 'notAnswered',
          subject: 'Mathematics',
        },
      ],
    },
  },
};

export const ComparativeAnalysisMockData = {
  comparativeData: {
    _id: '67285c3e6b7f0e07ff641ea9',
    test_id: '671923ae6bc3007257f366ec',
    __v: 0,
    accuracy: [
      {
        values: {
          topper: '100',
          average: '74.07299095100227',
          top_10_percent: '94.77854931840582',
          top_25_percent: '92.19991693076258',
        },
        _id: '6757c33573e94bc3676580d7',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '100',
          average: '61.18238451356804',
          top_10_percent: '89.77601709554877',
          top_25_percent: '85.65621081787731',
        },
        _id: '6757c33573e94bc3676580d8',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '100',
          average: '56.160249608693725',
          top_10_percent: '91.81641373186926',
          top_25_percent: '88.87708590561834',
        },
        _id: '6757c33573e94bc3676580d9',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
      {
        values: {
          topper: '100',
          average: '70.87166703227821',
          top_10_percent: '92.18443031949961',
          top_25_percent: '88.94664882446448',
        },
        _id: '6757c33573e94bc3676580da',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    attempt_analysis: [
      {
        _id: '6757c33573e94bc3676580af',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            title: 'Perfect',
            values: { topper: '24', average: '7', top_10_percent: '15', top_25_percent: '13' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '3', top_10_percent: '1', top_25_percent: '2' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '4', top_10_percent: '2', top_25_percent: '2' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '56.00000000000001',
        top_10_percent_attempt_percent: '92',
        top_25_percent_attempt_percent: '88',
      },

      {
        _id: '6757c33573e94bc3676580b4',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            title: 'Perfect',
            values: { topper: '23', average: '9', top_10_percent: '18', top_25_percent: '16' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '3', top_10_percent: '1', top_25_percent: '2' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '60',
        top_10_percent_attempt_percent: '92',
        top_25_percent_attempt_percent: '88',
      },

      {
        _id: '6757c33573e94bc3676580b9',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        values: [
          {
            title: 'Perfect',
            values: { topper: '24', average: '3', top_10_percent: '10', top_25_percent: '7' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '1', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Overtime',
            values: { topper: '0', average: '1', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '2', top_10_percent: '2', top_25_percent: '2' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '28.000000000000004',
        top_10_percent_attempt_percent: '80',
        top_25_percent_attempt_percent: '68',
      },

      {
        _id: '6757c33573e94bc3676580be',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            title: 'Perfect',
            values: { topper: '71', average: '19', top_10_percent: '43', top_25_percent: '36' },
          },
          {
            title: 'Wasted',
            values: { topper: '3', average: '5', top_10_percent: '3', top_25_percent: '3' },
          },
          {
            title: 'Overtime',
            values: { topper: '2', average: '6', top_10_percent: '3', top_25_percent: '3' },
          },
          {
            title: 'Confused',
            values: { topper: '3', average: '9', top_10_percent: '5', top_25_percent: '5' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '48',
        top_10_percent_attempt_percent: '88',
        top_25_percent_attempt_percent: '81.33333333333333',
      },
    ],
    createdAt: '2024-11-04T05:31:42.575Z',
    difficulty_analysis: [
      {
        _id: '6757c33573e94bc36765809f',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            values: {
              topper_correct: '12',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '7',
              average_incorrect: '1',
              average_unattempted: '3',
              top_10_percent_correct: '11',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '10',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '0',
            },
            _id: '6757c33573e94bc3676580a0',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '9',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '3',
              average_incorrect: '1',
              average_unattempted: '5',
              top_10_percent_correct: '7',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '6',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580a1',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '4',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '1',
              average_incorrect: '0',
              average_unattempted: '2',
              top_10_percent_correct: '3',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '2',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580a2',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580a3',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            values: {
              topper_correct: '9',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '4',
              average_incorrect: '1',
              average_unattempted: '4',
              top_10_percent_correct: '7',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '7',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580a4',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '9',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '3',
              average_incorrect: '1',
              average_unattempted: '3',
              top_10_percent_correct: '7',
              top_10_percent_incorrect: '1',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '6',
              top_25_percent_incorrect: '1',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580a5',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '7',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '3',
              average_incorrect: '1',
              average_unattempted: '2',
              top_10_percent_correct: '5',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '5',
              top_25_percent_unattempted: '0',
            },
            _id: '6757c33573e94bc3676580a6',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580a7',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        values: [
          {
            values: {
              topper_correct: '8',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '2',
              average_incorrect: '0',
              average_unattempted: '5',
              top_10_percent_correct: '6',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '5',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a8',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '13',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '2',
              average_incorrect: '0',
              average_unattempted: '9',
              top_10_percent_correct: '9',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '3',
              top_25_percent_correct: '7',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '5',
            },
            _id: '6757c33573e94bc3676580a9',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '4',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '0',
              average_incorrect: '0',
              average_unattempted: '3',
              top_10_percent_correct: '2',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '1',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580aa',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580ab',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            values: {
              topper_correct: '29',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '13',
              average_incorrect: '2',
              average_unattempted: '12',
              top_10_percent_correct: '24',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '2',
              top_25_percent_correct: '22',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '3',
            },
            _id: '6757c33573e94bc3676580ac',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '31',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '2',
              average_unattempted: '17',
              top_10_percent_correct: '23',
              top_10_percent_incorrect: '1',
              top_10_percent_unattempted: '4',
              top_25_percent_correct: '19',
              top_25_percent_incorrect: '1',
              top_25_percent_unattempted: '7',
            },
            _id: '6757c33573e94bc3676580ad',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '15',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '4',
              average_incorrect: '1',
              average_unattempted: '7',
              top_10_percent_correct: '10',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '8',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580ae',
            title: 'Tough',
          },
        ],
      },
    ],
    hour_wise_breakdown: [
      {
        values: {
          topper: {
            correct: 67,
            incorrect: 1,
            total: 68,
          },
          top_10_percent: {
            correct: 34,
            incorrect: 2,
            total: 36,
          },
          top_25_percent: {
            correct: 31,
            incorrect: 3,
            total: 34,
          },
          average: {
            correct: 19,
            incorrect: 5,
            total: 24,
          },
        },
        _id: '6757c33573e94bc36765809c',
        title: '1st Hour',
      },
      {
        values: {
          topper: {
            correct: 75,
            incorrect: 0,
            total: 75,
          },
          top_10_percent: {
            correct: 18,
            incorrect: 0,
            total: 18,
          },
          top_25_percent: {
            correct: 14,
            incorrect: 1,
            total: 15,
          },
          average: {
            correct: 6,
            incorrect: 1,
            total: 7,
          },
        },
        _id: '6757c33573e94bc36765809d',
        title: '2nd Hour',
      },
      {
        values: {
          topper: {
            correct: 0,
            incorrect: 0,
            total: 0,
          },
          top_10_percent: {
            correct: 11,
            incorrect: 0,
            total: 11,
          },
          top_25_percent: {
            correct: 10,
            incorrect: 0,
            total: 10,
          },
          average: {
            correct: 10,
            incorrect: 7,
            total: 17,
          },
        },
        _id: '6757c33573e94bc36765809e',
        title: '3rd Hour',
      },
    ],
    scores: [
      {
        values: {
          topper: '100',
          average: '47',
          top_10_percent: '87',
          top_25_percent: '79',
        },
        _id: '6757c33573e94bc3676580db',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '100',
          average: '41',
          top_10_percent: '81',
          top_25_percent: '72',
        },
        _id: '6757c33573e94bc3676580dc',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '100',
          average: '23',
          top_10_percent: '72',
          top_25_percent: '58',
        },
        _id: '6757c33573e94bc3676580dd',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
      {
        values: {
          topper: '300',
          average: '111',
          top_10_percent: '240',
          top_25_percent: '209',
        },
        _id: '6757c33573e94bc3676580de',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    test_breakdown: [
      {
        _id: '6757c33573e94bc3676580c3',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            values: {
              topper: '25',
              average: '11',
              top_10_percent: '21',
              top_25_percent: '18',
            },
            _id: '6757c33573e94bc3676580c4',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '2',
              top_10_percent: '0',
              top_25_percent: '0',
            },
            _id: '6757c33573e94bc3676580c5',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '11',
              top_10_percent: '2',
              top_25_percent: '3',
            },
            _id: '6757c33573e94bc3676580c6',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '1',
              top_10_percent: '2',
              top_25_percent: '4',
            },
            _id: '6757c33573e94bc3676580c7',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580c8',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            values: {
              topper: '25',
              average: '10',
              top_10_percent: '19',
              top_25_percent: '18',
            },
            _id: '6757c33573e94bc3676580c9',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '3',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580ca',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '10',
              top_10_percent: '2',
              top_25_percent: '3',
            },
            _id: '6757c33573e94bc3676580cb',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '2',
              top_10_percent: '3',
              top_25_percent: '3',
            },
            _id: '6757c33573e94bc3676580cc',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580cd',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        values: [
          {
            values: {
              topper: '25',
              average: '4',
              top_10_percent: '17',
              top_25_percent: '13',
            },
            _id: '6757c33573e94bc3676580ce',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '0',
              top_10_percent: '0',
              top_25_percent: '0',
            },
            _id: '6757c33573e94bc3676580cf',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '18',
              top_10_percent: '5',
              top_25_percent: '8',
            },
            _id: '6757c33573e94bc3676580d0',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '3',
              top_10_percent: '3',
              top_25_percent: '4',
            },
            _id: '6757c33573e94bc3676580d1',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580d2',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            values: {
              topper: '75',
              average: '25',
              top_10_percent: '57',
              top_25_percent: '49',
            },
            _id: '6757c33573e94bc3676580d3',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '5',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580d4',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '39',
              top_10_percent: '9',
              top_25_percent: '14',
            },
            _id: '6757c33573e94bc3676580d5',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '6',
              top_10_percent: '8',
              top_25_percent: '11',
            },
            _id: '6757c33573e94bc3676580d6',
            title: 'Not Visited',
          },
        ],
      },
    ],
    test_name: 'JEE Main 2024 (27 Jan Shift 1) - Updated as per Latest NTA Pattern',
    time_spent: [
      {
        values: {
          topper: '1093',
          average: '1958.2429977289933',
          top_10_percent: '2258.9172932330825',
          top_25_percent: '2316.359516616314',
        },
        _id: '6757c33573e94bc3676580df',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '1761',
          average: '1192.6850870552612',
          top_10_percent: '1392.9473684210527',
          top_25_percent: '1439.0815709969788',
        },
        _id: '6757c33573e94bc3676580e0',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '1900',
          average: '2374.1461014383044',
          top_10_percent: '4454.225563909775',
          top_25_percent: '4180.752265861027',
        },
        _id: '6757c33573e94bc3676580e1',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
      {
        values: {
          topper: '4754',
          average: '5524',
          top_10_percent: '8104',
          top_25_percent: '7935',
        },
        _id: '6757c33573e94bc3676580e2',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    updatedAt: '2024-12-10T04:27:33.405Z',
  },
  userData: {
    accuracy: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        accuracy: 95.83333333333334,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        accuracy: 100,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        accuracy: 93.33333333333333,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        accuracy: 96.61016949152543,
      },
    ],
    attempt_analysis: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        perfect_attempts: 20,
        overtime_attempts: 0,
        confused_attempts: 0,
        wasted_attempts: 0,
        attempt_percentage: '96.00',
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        perfect_attempts: 19,
        overtime_attempts: 0,
        confused_attempts: 0,
        wasted_attempts: 0,
        attempt_percentage: '80.00',
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        perfect_attempts: 7,
        overtime_attempts: 0,
        confused_attempts: 3,
        wasted_attempts: 0,
        attempt_percentage: '60.00',
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        perfect_attempts: 46,
        overtime_attempts: 0,
        confused_attempts: 3,
        wasted_attempts: 0,
        attempt_percentage: '78.67',
      },
    ],
    difficulty_analysis: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        easyCorrect: 12,
        easyIncorrect: 0,
        easyUnattempted: 0,
        moderateCorrect: 7,
        moderateIncorrect: 1,
        moderateUnattempted: 1,
        toughCorrect: 4,
        toughIncorrect: 0,
        toughUnattempted: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        easyCorrect: 6,
        easyIncorrect: 0,
        easyUnattempted: 3,
        moderateCorrect: 8,
        moderateIncorrect: 0,
        moderateUnattempted: 1,
        toughCorrect: 6,
        toughIncorrect: 0,
        toughUnattempted: 1,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        easyCorrect: 6,
        easyIncorrect: 0,
        easyUnattempted: 2,
        moderateCorrect: 5,
        moderateIncorrect: 1,
        moderateUnattempted: 7,
        toughCorrect: 3,
        toughIncorrect: 0,
        toughUnattempted: 1,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        easyCorrect: 24,
        easyIncorrect: 0,
        easyUnattempted: 5,
        moderateCorrect: 20,
        moderateIncorrect: 2,
        moderateUnattempted: 9,
        toughCorrect: 13,
        toughIncorrect: 0,
        toughUnattempted: 2,
      },
    ],
    hour_wise_breakdown: [
      {
        title: '1st Hour',
        values: {
          correct: 43,
          incorrect: 2,
          total: 45,
        },
      },
      {
        title: '2nd Hour',
        values: {
          correct: 14,
          incorrect: 0,
          total: 14,
        },
      },
      {
        title: '3rd Hour',
        values: {
          correct: 0,
          incorrect: 0,
          total: 0,
        },
      },
    ],
    scores: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        score: 91,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        score: 80,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        score: 55,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        score: 226,
      },
    ],
    test_breakdown: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        correct: 23,
        incorrect: 1,
        unattempted: 1,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        correct: 20,
        incorrect: 0,
        unattempted: 5,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        correct: 14,
        incorrect: 1,
        unattempted: 10,
        notVisited: 0,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        correct: 57,
        incorrect: 2,
        unattempted: 16,
        notVisited: 0,
      },
    ],
    time_spent: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        time_spent: 1727,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        time_spent: 1243,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        time_spent: 3798,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        time_spent: 6768,
      },
    ],
  },
  subjectMeta: {
    Physics: {
      id: '607018ee404ae53194e73d90',
      title: 'Physics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
      color: '#37B24D',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    Chemistry: {
      id: '607018ee404ae53194e73d91',
      title: 'Chemistry',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
      color: '#FF8C33',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
    },
    Mathematics: {
      id: '607018ee404ae53194e73d92',
      title: 'Mathematics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
      color: '#0086FF',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
    },
    Overall: {
      id: 'overall',
      title: 'Overall',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
      color: '#364FC7',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
  },
  difficultyWiseQuestions: {
    Physics: {
      easy: 12,
      moderate: 9,
      tough: 4,
    },
    Chemistry: {
      easy: 9,
      moderate: 9,
      tough: 7,
    },
    Mathematics: {
      easy: 8,
      moderate: 13,
      tough: 4,
    },
  },
  totalQuestions: {
    total: 75,
    '607018ee404ae53194e73d90': 25,
    '607018ee404ae53194e73d91': 25,
    '607018ee404ae53194e73d92': 25,
  },
};

export const PercentileMockData = {
  percentileData: {
    _id: '673c75ef2621a3331bdc7b55',
    title: 'JEE Main 2024 (27 Jan Shift 1)',
    description: 'This percentile calculation is done on the basis of JEE Main 2024 (27 Jan Shift 1) data',
    consolationText:
      'Buckle up! Your score is below the 90 percentile. Analyze properly and keep pushing forward to improve.',
    data: [
      {
        _id: '673c75ef2621a3331bdc7b56',
        percentile: 99.9,
        score: 278,
      },
      {
        _id: '673c75ef2621a3331bdc7b57',
        percentile: 99.8875,
        score: 277,
      },
      {
        _id: '673c75ef2621a3331bdc7b58',
        percentile: 99.875,
        score: 276,
      },
      {
        _id: '673c75ef2621a3331bdc7b59',
        percentile: 99.8625,
        score: 275,
      },
      {
        _id: '673c75ef2621a3331bdc7b5a',
        percentile: 99.85,
        score: 274,
      },
      {
        _id: '673c75ef2621a3331bdc7b5b',
        percentile: 99.8375,
        score: 273,
      },
      {
        _id: '673c75ef2621a3331bdc7b5c',
        percentile: 99.825,
        score: 272,
      },
      {
        _id: '673c75ef2621a3331bdc7b5d',
        percentile: 99.8125,
        score: 271,
      },
      {
        _id: '673c75ef2621a3331bdc7b5e',
        percentile: 99.8,
        score: 270,
      },
      {
        _id: '673c75ef2621a3331bdc7b5f',
        percentile: 99.78,
        score: 269,
      },
      {
        _id: '673c75ef2621a3331bdc7b60',
        percentile: 99.76,
        score: 268,
      },
      {
        _id: '673c75ef2621a3331bdc7b61',
        percentile: 99.74,
        score: 267,
      },
      {
        _id: '673c75ef2621a3331bdc7b62',
        percentile: 99.72,
        score: 266,
      },
      {
        _id: '673c75ef2621a3331bdc7b63',
        percentile: 99.7,
        score: 265,
      },
      {
        _id: '673c75ef2621a3331bdc7b64',
        percentile: 99.683333,
        score: 264,
      },
      {
        _id: '673c75ef2621a3331bdc7b65',
        percentile: 99.666667,
        score: 263,
      },
      {
        _id: '673c75ef2621a3331bdc7b66',
        percentile: 99.65,
        score: 262,
      },
      {
        _id: '673c75ef2621a3331bdc7b67',
        percentile: 99.633333,
        score: 261,
      },
      {
        _id: '673c75ef2621a3331bdc7b68',
        percentile: 99.616667,
        score: 260,
      },
      {
        _id: '673c75ef2621a3331bdc7b69',
        percentile: 99.6,
        score: 259,
      },
      {
        _id: '673c75ef2621a3331bdc7b6a',
        percentile: 99.58,
        score: 258,
      },
      {
        _id: '673c75ef2621a3331bdc7b6b',
        percentile: 99.56,
        score: 257,
      },
      {
        _id: '673c75ef2621a3331bdc7b6c',
        percentile: 99.54,
        score: 256,
      },
      {
        _id: '673c75ef2621a3331bdc7b6d',
        percentile: 99.52,
        score: 255,
      },
      {
        _id: '673c75ef2621a3331bdc7b6e',
        percentile: 99.5,
        score: 254,
      },
      {
        _id: '673c75ef2621a3331bdc7b6f',
        percentile: 99.475,
        score: 253,
      },
      {
        _id: '673c75ef2621a3331bdc7b70',
        percentile: 99.45,
        score: 252,
      },
      {
        _id: '673c75ef2621a3331bdc7b71',
        percentile: 99.425,
        score: 251,
      },
      {
        _id: '673c75ef2621a3331bdc7b72',
        percentile: 99.4,
        score: 250,
      },
      {
        _id: '673c75ef2621a3331bdc7b73',
        percentile: 99.38,
        score: 249,
      },
      {
        _id: '673c75ef2621a3331bdc7b74',
        percentile: 99.36,
        score: 248,
      },
      {
        _id: '673c75ef2621a3331bdc7b75',
        percentile: 99.34,
        score: 247,
      },
      {
        _id: '673c75ef2621a3331bdc7b76',
        percentile: 99.32,
        score: 246,
      },
      {
        _id: '673c75ef2621a3331bdc7b77',
        percentile: 99.3,
        score: 245,
      },
      {
        _id: '673c75ef2621a3331bdc7b78',
        percentile: 99.266667,
        score: 244,
      },
      {
        _id: '673c75ef2621a3331bdc7b79',
        percentile: 99.233333,
        score: 243,
      },
      {
        _id: '673c75ef2621a3331bdc7b7a',
        percentile: 99.2,
        score: 242,
      },
      {
        _id: '673c75ef2621a3331bdc7b7b',
        percentile: 99.166667,
        score: 241,
      },
      {
        _id: '673c75ef2621a3331bdc7b7c',
        percentile: 99.133333,
        score: 240,
      },
      {
        _id: '673c75ef2621a3331bdc7b7d',
        percentile: 99.1,
        score: 239,
      },
      {
        _id: '673c75ef2621a3331bdc7b7e',
        percentile: 99.066667,
        score: 238,
      },
      {
        _id: '673c75ef2621a3331bdc7b7f',
        percentile: 99.033333,
        score: 237,
      },
      {
        _id: '673c75ef2621a3331bdc7b80',
        percentile: 99,
        score: 236,
      },
      {
        _id: '673c75ef2621a3331bdc7b81',
        percentile: 98.961538,
        score: 235,
      },
      {
        _id: '673c75ef2621a3331bdc7b82',
        percentile: 98.923077,
        score: 234,
      },
      {
        _id: '673c75ef2621a3331bdc7b83',
        percentile: 98.884615,
        score: 233,
      },
      {
        _id: '673c75ef2621a3331bdc7b84',
        percentile: 98.846154,
        score: 232,
      },
      {
        _id: '673c75ef2621a3331bdc7b85',
        percentile: 98.807692,
        score: 231,
      },
      {
        _id: '673c75ef2621a3331bdc7b86',
        percentile: 98.769231,
        score: 230,
      },
      {
        _id: '673c75ef2621a3331bdc7b87',
        percentile: 98.730769,
        score: 229,
      },
      {
        _id: '673c75ef2621a3331bdc7b88',
        percentile: 98.692308,
        score: 228,
      },
      {
        _id: '673c75ef2621a3331bdc7b89',
        percentile: 98.653846,
        score: 227,
      },
      {
        _id: '673c75ef2621a3331bdc7b8a',
        percentile: 98.615385,
        score: 226,
      },
      {
        _id: '673c75ef2621a3331bdc7b8b',
        percentile: 98.576923,
        score: 225,
      },
      {
        _id: '673c75ef2621a3331bdc7b8c',
        percentile: 98.538462,
        score: 224,
      },
      {
        _id: '673c75ef2621a3331bdc7b8d',
        percentile: 98.5,
        score: 223,
      },
      {
        _id: '673c75ef2621a3331bdc7b8e',
        percentile: 98.45,
        score: 222,
      },
      {
        _id: '673c75ef2621a3331bdc7b8f',
        percentile: 98.4,
        score: 221,
      },
      {
        _id: '673c75ef2621a3331bdc7b90',
        percentile: 98.35,
        score: 220,
      },
      {
        _id: '673c75ef2621a3331bdc7b91',
        percentile: 98.3,
        score: 219,
      },
      {
        _id: '673c75ef2621a3331bdc7b92',
        percentile: 98.25,
        score: 218,
      },
      {
        _id: '673c75ef2621a3331bdc7b93',
        percentile: 98.2,
        score: 217,
      },
      {
        _id: '673c75ef2621a3331bdc7b94',
        percentile: 98.15,
        score: 216,
      },
      {
        _id: '673c75ef2621a3331bdc7b95',
        percentile: 98.1,
        score: 215,
      },
      {
        _id: '673c75ef2621a3331bdc7b96',
        percentile: 98.05,
        score: 214,
      },
      {
        _id: '673c75ef2621a3331bdc7b97',
        percentile: 98,
        score: 213,
      },
      {
        _id: '673c75ef2621a3331bdc7b98',
        percentile: 97.944444,
        score: 212,
      },
      {
        _id: '673c75ef2621a3331bdc7b99',
        percentile: 97.888889,
        score: 211,
      },
      {
        _id: '673c75ef2621a3331bdc7b9a',
        percentile: 97.833333,
        score: 210,
      },
      {
        _id: '673c75ef2621a3331bdc7b9b',
        percentile: 97.777778,
        score: 209,
      },
      {
        _id: '673c75ef2621a3331bdc7b9c',
        percentile: 97.722222,
        score: 208,
      },
      {
        _id: '673c75ef2621a3331bdc7b9d',
        percentile: 97.666667,
        score: 207,
      },
      {
        _id: '673c75ef2621a3331bdc7b9e',
        percentile: 97.611111,
        score: 206,
      },
      {
        _id: '673c75ef2621a3331bdc7b9f',
        percentile: 97.555556,
        score: 205,
      },
      {
        _id: '673c75ef2621a3331bdc7ba0',
        percentile: 97.5,
        score: 204,
      },
      {
        _id: '673c75ef2621a3331bdc7ba1',
        percentile: 97.4375,
        score: 203,
      },
      {
        _id: '673c75ef2621a3331bdc7ba2',
        percentile: 97.375,
        score: 202,
      },
      {
        _id: '673c75ef2621a3331bdc7ba3',
        percentile: 97.3125,
        score: 201,
      },
      {
        _id: '673c75ef2621a3331bdc7ba4',
        percentile: 97.25,
        score: 200,
      },
      {
        _id: '673c75ef2621a3331bdc7ba5',
        percentile: 97.1875,
        score: 199,
      },
      {
        _id: '673c75ef2621a3331bdc7ba6',
        percentile: 97.125,
        score: 198,
      },
      {
        _id: '673c75ef2621a3331bdc7ba7',
        percentile: 97.0625,
        score: 197,
      },
      {
        _id: '673c75ef2621a3331bdc7ba8',
        percentile: 97,
        score: 196,
      },
      {
        _id: '673c75ef2621a3331bdc7ba9',
        percentile: 96.916667,
        score: 195,
      },
      {
        _id: '673c75ef2621a3331bdc7baa',
        percentile: 96.833333,
        score: 194,
      },
      {
        _id: '673c75ef2621a3331bdc7bab',
        percentile: 96.75,
        score: 193,
      },
      {
        _id: '673c75ef2621a3331bdc7bac',
        percentile: 96.666667,
        score: 192,
      },
      {
        _id: '673c75ef2621a3331bdc7bad',
        percentile: 96.583333,
        score: 191,
      },
      {
        _id: '673c75ef2621a3331bdc7bae',
        percentile: 96.5,
        score: 190,
      },
      {
        _id: '673c75ef2621a3331bdc7baf',
        percentile: 96.416667,
        score: 189,
      },
      {
        _id: '673c75ef2621a3331bdc7bb0',
        percentile: 96.333333,
        score: 188,
      },
      {
        _id: '673c75ef2621a3331bdc7bb1',
        percentile: 96.25,
        score: 187,
      },
      {
        _id: '673c75ef2621a3331bdc7bb2',
        percentile: 96.166667,
        score: 186,
      },
      {
        _id: '673c75ef2621a3331bdc7bb3',
        percentile: 96.083333,
        score: 185,
      },
      {
        _id: '673c75ef2621a3331bdc7bb4',
        percentile: 96,
        score: 184,
      },
      {
        _id: '673c75ef2621a3331bdc7bb5',
        percentile: 95.916667,
        score: 183,
      },
      {
        _id: '673c75ef2621a3331bdc7bb6',
        percentile: 95.833333,
        score: 182,
      },
      {
        _id: '673c75ef2621a3331bdc7bb7',
        percentile: 95.75,
        score: 181,
      },
      {
        _id: '673c75ef2621a3331bdc7bb8',
        percentile: 95.666667,
        score: 180,
      },
      {
        _id: '673c75ef2621a3331bdc7bb9',
        percentile: 95.583333,
        score: 179,
      },
      {
        _id: '673c75ef2621a3331bdc7bba',
        percentile: 95.5,
        score: 178,
      },
      {
        _id: '673c75ef2621a3331bdc7bbb',
        percentile: 95.4,
        score: 177,
      },
      {
        _id: '673c75ef2621a3331bdc7bbc',
        percentile: 95.3,
        score: 176,
      },
      {
        _id: '673c75ef2621a3331bdc7bbd',
        percentile: 95.2,
        score: 175,
      },
      {
        _id: '673c75ef2621a3331bdc7bbe',
        percentile: 95.1,
        score: 174,
      },
      {
        _id: '673c75ef2621a3331bdc7bbf',
        percentile: 95,
        score: 173,
      },
      {
        _id: '673c75ef2621a3331bdc7bc0',
        percentile: 94.875,
        score: 172,
      },
      {
        _id: '673c75ef2621a3331bdc7bc1',
        percentile: 94.75,
        score: 171,
      },
      {
        _id: '673c75ef2621a3331bdc7bc2',
        percentile: 94.625,
        score: 170,
      },
      {
        _id: '673c75ef2621a3331bdc7bc3',
        percentile: 94.5,
        score: 169,
      },
      {
        _id: '673c75ef2621a3331bdc7bc4',
        percentile: 94.375,
        score: 168,
      },
      {
        _id: '673c75ef2621a3331bdc7bc5',
        percentile: 94.25,
        score: 167,
      },
      {
        _id: '673c75ef2621a3331bdc7bc6',
        percentile: 94.125,
        score: 166,
      },
      {
        _id: '673c75ef2621a3331bdc7bc7',
        percentile: 94,
        score: 165,
      },
      {
        _id: '673c75ef2621a3331bdc7bc8',
        percentile: 93.875,
        score: 164,
      },
      {
        _id: '673c75ef2621a3331bdc7bc9',
        percentile: 93.75,
        score: 163,
      },
      {
        _id: '673c75ef2621a3331bdc7bca',
        percentile: 93.625,
        score: 162,
      },
      {
        _id: '673c75ef2621a3331bdc7bcb',
        percentile: 93.5,
        score: 161,
      },
      {
        _id: '673c75ef2621a3331bdc7bcc',
        percentile: 93.375,
        score: 160,
      },
      {
        _id: '673c75ef2621a3331bdc7bcd',
        percentile: 93.25,
        score: 159,
      },
      {
        _id: '673c75ef2621a3331bdc7bce',
        percentile: 93.125,
        score: 158,
      },
      {
        _id: '673c75ef2621a3331bdc7bcf',
        percentile: 93,
        score: 157,
      },
      {
        _id: '673c75ef2621a3331bdc7bd0',
        percentile: 92.833333,
        score: 156,
      },
      {
        _id: '673c75ef2621a3331bdc7bd1',
        percentile: 92.666667,
        score: 155,
      },
      {
        _id: '673c75ef2621a3331bdc7bd2',
        percentile: 92.5,
        score: 154,
      },
      {
        _id: '673c75ef2621a3331bdc7bd3',
        percentile: 92.333333,
        score: 153,
      },
      {
        _id: '673c75ef2621a3331bdc7bd4',
        percentile: 92.166667,
        score: 152,
      },
      {
        _id: '673c75ef2621a3331bdc7bd5',
        percentile: 92,
        score: 151,
      },
      {
        _id: '673c75ef2621a3331bdc7bd6',
        percentile: 91.833333,
        score: 150,
      },
      {
        _id: '673c75ef2621a3331bdc7bd7',
        percentile: 91.666667,
        score: 149,
      },
      {
        _id: '673c75ef2621a3331bdc7bd8',
        percentile: 91.5,
        score: 148,
      },
      {
        _id: '673c75ef2621a3331bdc7bd9',
        percentile: 91.333333,
        score: 147,
      },
      {
        _id: '673c75ef2621a3331bdc7bda',
        percentile: 91.166667,
        score: 146,
      },
      {
        _id: '673c75ef2621a3331bdc7bdb',
        percentile: 91,
        score: 145,
      },
      {
        _id: '673c75ef2621a3331bdc7bdc',
        percentile: 90.833333,
        score: 144,
      },
      {
        _id: '673c75ef2621a3331bdc7bdd',
        percentile: 90.666667,
        score: 143,
      },
      {
        _id: '673c75ef2621a3331bdc7bde',
        percentile: 90.5,
        score: 142,
      },
      {
        _id: '673c75ef2621a3331bdc7bdf',
        percentile: 90.333333,
        score: 141,
      },
      {
        _id: '673c75ef2621a3331bdc7be0',
        percentile: 90.166667,
        score: 140,
      },
      {
        _id: '673c75ef2621a3331bdc7be1',
        percentile: 90,
        score: 139,
      },
    ],
    createdAt: '2024-11-19T16:56:39.111Z',
    updatedAt: '2024-11-19T16:56:39.111Z',
    __v: 0,
  },
  isAvailable: true,
  version: 1,
};
